// @ts-nocheck

/* eslint-disable class-methods-use-this */

/* eslint-disable object-curly-spacing */

/* eslint-disable arrow-body-style */

/* eslint-disable no-template-curly-in-string */
import {
  faCog,
  faGenderless,
  faListAlt,
  faUser,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Checkbox, RadioButton, TextField } from '@shopify/polaris';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import PropTypes from 'prop-types';
import Radium from 'radium';
import React from 'react';
import { Col, Form, FormControl, FormGroup, Modal, Row } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
// import ReactTable from 'react-table';
import { usePagination, useSortBy, useTable } from 'react-table';
import { bindActionCreators, compose } from 'redux';

import '../../../node_modules/react-s-alert/dist/s-alert-css-effects/bouncyflip.css';
// import 'react-table/react-table.css';
import '../../../node_modules/react-s-alert/dist/s-alert-default.css';
import * as adminActions from '../../actions/adminActions';
import * as appActions from '../../actions/appActions';
import * as eventActions from '../../actions/eventActions';
import * as hosts from '../../actions/hostLocations';
import * as userActions from '../../actions/userActions';

import { ACTIVE_HOST } from '@api/host';

const swal = require('sweetalert2'); // eslint-disable-line
const moment = require('moment');
const Spinner = require('react-spinkit');

const isiPad = navigator.userAgent.match(/iPad/i) != null; // eslint-disable-line

function roughSizeOfObject(object: any) {
  // return JSON.stringify(object).length;
  var objectList = [];
  var stack = [object];
  var bytes = 0;

  while (stack.length) {
    var value = stack.pop();

    if (typeof value === 'boolean') {
      bytes += 4;
    } else if (typeof value === 'string') {
      bytes += value.length * 2;
    } else if (typeof value === 'number') {
      bytes += 8;
    } else if (typeof value === 'object' && objectList.indexOf(value) === -1) {
      objectList.push(value);

      for (var i in value) {
        stack.push(value[i]);
      }
    }
  }
  const kilobytes = bytes / 1024;
  return kilobytes;
}

function Table({
  columns,
  data,
  pageManual,
  pageSizeManual,
  pageCount: controlledPageCount,
  onPageChange,
  onPageSizeChange,
  loading,
}: any) {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page

    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    sortBy,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: pageManual, pageSize: pageSizeManual },
      manualPagination: true,
      pageCount: controlledPageCount,
    },
    useSortBy,
    usePagination,
  );

  // Render the UI for your table
  return (
    <div style={{ width: '100%', position: 'relative', textAlign: 'center' }}>
      <div
        style={{
          fontFamily: 'Inter',
          padding: 10,
          backgroundColor: '#FFFFFF',
          borderRadius: 4,
          border: '1px solid #E7E7E7',
          overflowY: 'scroll',
          height: 500,
        }}
      >
        <table
          {...getTableProps()}
          style={{ width: '100%', borderRadius: 10, marginRight: 10 }}
        >
          <thead>
            {headerGroups.map(headerGroup => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th
                    {...column.getHeaderProps()}
                    style={{
                      borderStyle: 'none',
                      padding: '5px 15px',
                      borderWidth: 0,
                      backgroundColor: '#F7F8FA',
                      minWidth: 150,
                    }}
                  >
                    {column.render('Header')}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row: any, i: any) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell: any) => {
                    return (
                      <td
                        {...cell.getCellProps()}
                        style={{
                          borderBottomStyle: 'solid',
                          padding: 5,
                          borderBottomWidth: 1,
                          borderBottomColor: '#E7E7E7',
                          backgroundColor: '#FFFFFF',
                        }}
                      >
                        {cell.render('Cell')}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {loading ? (
        <div
          style={{
            position: 'absolute',
            left: 0,
            top: 0,
            height: '100%',
            width: '100%',
            display: 'flex',
            alignItem: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 9001,
          }}
        >
          <Spinner />
        </div>
      ) : null}
      <div className="pagination">
        <Row style={{ width: '100%', marginTop: 10, marginBottom: 100 }}>
          <Col xs={{ span: 2 }}>
            <button
              style={
                canPreviousPage
                  ? styles.paginationButton
                  : styles.paginationButtonDisabled
              }
              onClick={() => {
                previousPage();
                onPageChange(pageIndex - 1);
              }}
              disabled={!canPreviousPage}
            >
              {'Previous'}
            </button>
          </Col>
          <Col xs={{ span: 8, textAlign: 'center' }}>
            <p
              style={{
                fontFamily: 'Inter',
                fontStyle: 'normal',
                fontSize: 16,
                fontWeight: 500,
                marginRight: '10px',
                marginTop: '0px',
                padding: 10,
                display: 'inline-block',
              }}
            >
              <span>Page </span>
              <input
                type="number"
                defaultValue={pageIndex + 1}
                value={pageIndex + 1}
                onChange={e => {
                  const page = e.target.value ? Number(e.target.value) - 1 : 0;
                  gotoPage(page);
                }}
                style={{ ...styles.goToPageInputShort, paddingLeft: 5 }}
              />{' '}
              of {pageOptions.length}{' '}
            </p>{' '}
            <select
              value={pageSize}
              onChange={e => {
                onPageSizeChange(Number(e.target.value), 0);
                setPageSize(Number(e.target.value));
              }}
              style={styles.goToPageInput}
            >
              {[15, 30, 45, 60].map(pageSize => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize} Rows
                </option>
              ))}
            </select>
          </Col>
          <Col xs={{ span: 2 }}>
            <button
              style={
                canNextPage
                  ? styles.paginationButton
                  : styles.paginationButtonDisabled
              }
              onClick={() => {
                nextPage();
                onPageChange(pageIndex + 1);
              }}
              disabled={!canNextPage}
            >
              {'Next'}
            </button>
          </Col>
        </Row>
      </div>
    </div>
  );
}

const styles = {
  section: {
    height: '100%',
    width: '100%',
    padding: 20,
  },
  item: {
    padding: '5px 5px',
    fontWeight: 400,
    color: 'black',
    fontSize: 14,
  },
  clearBar: {
    backgroundColor: '#FFFFFF',
    borderWidth: 0,
    marginBottom: 0,
  },
  header: {
    color: '#8da2b5',
    borderBottom: 'none',
    fontWeight: 300,
    fontSize: 12,
    fontFamily: 'Inter',
  },
  headerSortable: {
    color: '#8da2b5',
    borderBottom: 'none',
    fontWeight: 300,
    fontSize: 12,
    fontFamily: 'Inter',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  topHeader: {
    backgroundColor: 'white',
    marginBottom: 20,
    padding: '15px 10px',
    borderBottom: '1px solid #FF7C00',
  },
  modalLink: {
    cursor: 'pointer',
    display: 'block',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    textDecoration: 'underline',
  },
  faIcon: {
    marginRight: 10,
  },
  searchInput: {
    background: '#FFF',
    border: '1px solid rgb(215, 214, 219)',
    borderRadius: 4,
    boxSizing: 'border-box',
    color: '#25252e',
    fontFamily: 'Inter',
    fontSize: '19px',
    fontStyle: 'normal',
    fontWeight: 500,
    height: '50px',
    letterSpacing: '-0.014em',
    textAlign: 'left',
    width: '100%',
  },
  paginationButton: {
    background: '#FFFFFF',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '16px',
    lineHeight: '24px',
    border: '1px solid #D7D6DB',
    boxSizing: 'border-box',
    borderRadius: '4px',
    width: 150,
    padding: 10,
    color: '#25252E',
  },
  paginationButtonDisabled: {
    background: '#FFFFFF',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '16px',
    lineHeight: '24px',
    border: '1px solid #D7D6DB',
    boxSizing: 'border-box',
    borderRadius: '4px',
    width: 150,
    padding: 10,
    color: '#D7D6DB',
  },
  goToPageInputShort: {
    background: '#FFF',
    border: '1px solid #d7d6db',
    borderRadius: 4,
    boxSizing: 'border-box',
    color: '#25252e',
    fontFamily: 'Inter',
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 500,
    height: 30,
    width: 40,
    letterSpacing: '-0.014em',
    textAlign: 'left',
  },
  goToPageInput: {
    background: '#FFF',
    border: '1px solid #d7d6db',
    borderRadius: 4,
    boxSizing: 'border-box',
    color: '#25252e',
    fontFamily: 'Inter',
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 500,
    height: 30,
    letterSpacing: '-0.014em',
    textAlign: 'left',
  },
};

class AllAppsPage extends React.Component {
  constructor(props: any, context: any) {
    super(props, context);

    this.state = {
      data: [],
      loading: false,
      page: 0,
      pageSize: 10,
      totalPages: 1,
      totalApps: 0,
      sorted: [],
      filtered: [],
      searchString: '',
      displayColumns: {
        title: true,
        created: true,
        tools: true,
        archived: true,
        payment: true,
        store: true,
        billing: true,
        fullName: true,
        tier: true,
        activeUsers: true,
        deploymentStatus: true,
      },
      billingOverviewInfo: {
        dateSince: '',
        currentPlan: '',
        accountStatus: '',
      },
      showBillingModal: false,
      showEditPackageIdModal: false,
      appToBeEdited: '',
      appToBeEditedOptions: {},
      packageIdString: '',
      showAppStoreModal: false,
      itunesString: '',
      playStoreString: '',
      androidVersionString: '',
      appleVersionString: '',
      appForModal: {},
      showAppOptionsModal: false,
      specialSearch: '',
      showShopifyInfoModal: false,
      loadingShopifyInfo: false,
      shopifyInfo: {},
      shopifyInfoError: '',
      shopifyClearTokens: false,
      archiveMode: false,
      customerMode: false,
      checkedArray: [],
      showFurtherDetailsModal: false,
      appBeingExamined: {},
      loadingEvents: false,
      appEvents: [],
      showEditTrialModal: false,
      showEditShopifyTrialModal: false,
      showEditSubscriptionModal: false,
      shopifyTrialEndString: '',
      showEditUserCountModal: false,
      userCountString: '',
      deploymentStatusStringIOS: '',
      deploymentStatusStringANDROID: '',
      customerSupportPlanToBeEdited: '',
      customerSupportCustomPriceToBeEdited: 0,
      showEditDeploymentStatusModal: false,
      showEditCustomerSupportTierModal: false,
      showCustomerConfirmationSwal: false,
      customerConfirmationSwalPlan: '',
      customerConfirmationSwalPrice: 0,
      customerConfirmationSwalNumberOfDays: 0,
      customerConfirmationSwalPlatform: '',
      customerConfirmationSwalBillDate: '',
    };
    this.prettifyDate = this.prettifyDate.bind(this);
    this.fetchData = this.fetchData.bind(this);
    this.fetchDataCallback = this.fetchDataCallback.bind(this);
    this.updateSearchString = this.updateSearchString.bind(this);
    this.deleteApp = this.deleteApp.bind(this);
    this.undeleteApp = this.undeleteApp.bind(this);
    this.makeAdmin = this.makeAdmin.bind(this);
    this.setAsPartner = this.setAsPartner.bind(this);
    this.partnerPaywallSkip = this.partnerPaywallSkip.bind(this);
    this.preUseApp = this.preUseApp.bind(this);
    this.useApp = this.useApp.bind(this);
    this.useAppCallback = this.useAppCallback.bind(this);
    this.openEditDeploymentStatusModal =
      this.openEditDeploymentStatusModal.bind(this);
    this.openEditCustomerSupportTierModal =
      this.openEditCustomerSupportTierModal.bind(this);
    this.openEditPackageIdModal = this.openEditPackageIdModal.bind(this);
    this.openEditSubscriptionModal = this.openEditSubscriptionModal.bind(this);
    this.updatePackageId = this.updatePackageId.bind(this);
    this.updatePackageIdState = this.updatePackageIdState.bind(this);
    this.updateSubscriptionPlan = this.updateSubscriptionPlan.bind(this);
    this.updateSubscriptionPlanState =
      this.updateSubscriptionPlanState.bind(this);
    this.updateDeploymentStatus = this.updateDeploymentStatus.bind(this);
    this.updateDeploymentStatusState =
      this.updateDeploymentStatusState.bind(this);
    this.updateCustomerSupportTierState =
      this.updateCustomerSupportTierState.bind(this);
    this.updateCustomerSupportCustomPriceState =
      this.updateCustomerSupportCustomPriceState.bind(this);
    this.updateCustomerSupportTier = this.updateCustomerSupportTier.bind(this);
    this.prePreUpdateCustomerSupportTier =
      this.prePreUpdateCustomerSupportTier.bind(this);
    this.preUpdateCustomerSupportTier =
      this.preUpdateCustomerSupportTier.bind(this);
    this.openEditTrialModal = this.openEditTrialModal.bind(this);
    this.openEditStoreLinkModal = this.openEditStoreLinkModal.bind(this);
    this.updateStoreLinkState = this.updateStoreLinkState.bind(this);
    this.updateStoreLinks = this.updateStoreLinks.bind(this);
    this.openAdminAppModal = this.openAdminAppModal.bind(this);
    this.closeAdminAppModal = this.closeAdminAppModal.bind(this);
    this.onlyStore = this.onlyStore.bind(this);
    this.getMoreShopifyInfo = this.getMoreShopifyInfo.bind(this);
    this.closeShopifyInfoModal = this.closeShopifyInfoModal.bind(this);
    this.cancelShopifySub = this.cancelShopifySub.bind(this);
    this.clearShopifyTokens = this.clearShopifyTokens.bind(this);
    this.changeMode = this.changeMode.bind(this);
    this.checkApp = this.checkApp.bind(this);
    this.openFurtherDetailsModal = this.openFurtherDetailsModal.bind(this);
    this.loadAppEvents = this.loadAppEvents.bind(this);
    this.useAppSocialCallback = this.useAppSocialCallback.bind(this);
    this.quickFix = this.quickFix.bind(this);
    this.updateTrial = this.updateTrial.bind(this);
    this.updateTrialEndState = this.updateTrialEndState.bind(this);
    this.handleSorting = this.handleSorting.bind(this);
    this.openEditShopifyTrialModal = this.openEditShopifyTrialModal.bind(this);
    this.updateShopifyTrialEndState =
      this.updateShopifyTrialEndState.bind(this);
    this.updateShopifyTrial = this.updateShopifyTrial.bind(this);
    this.updateUserCountState = this.updateUserCountState.bind(this);
    this.updateUserCount = this.updateUserCount.bind(this);
    this.openEditUserCountModal = this.openEditUserCountModal.bind(this);
    this.userInstalledCheck = this.userInstalledCheck.bind(this);
    this.markAsCancelled = this.markAsCancelled.bind(this);
  }

  componentDidMount() {
    this.fetchData({ page: this.state.page, pageSize: this.state.pageSize });
  }

  fetchData(event: any) {
    this.setState({ loading: true, checkedArray: [] });

    // alert(JSON.stringify(event));
    let searchString = this.state.searchString;
    if (this.state.specialSearch) {
      searchString = this.state.specialSearch;
      this.setState({ specialSearch: '' });
    }

    // alert('start')
    this.props.actions.admin.fetchPaginatedFilteredData(
      event.pageSize,
      event.page,
      this.state.sorted,
      searchString,
      this.state.customerMode,
      this.state.archiveMode,
      this.fetchDataCallback,
    );
  }

  fetchDataCallback(response: any) {
    // alert('end');
    this.setState({
      data: response.rows,
      totalPages: response.pages,
      totalApps: response.totalApps,
      loading: false,
    });
  }

  updateSearchString(value: any) {
    this.setState({ searchString: value }, () => {
      if (this.state.searchString === '') {
        this.fetchData({
          page: this.state.page,
          pageSize: this.state.pageSize,
        });
      }
    });
  }

  onlyStore(value: any) {
    this.setState({ specialSearch: value, searchString: value }, () => {
      this.fetchData({ page: this.state.page, pageSize: this.state.pageSize });
    });
  }

  openEditTrialModal(app: any) {
    this.setState({ showEditTrialModal: true, appToBeEdited: app._id });
  }

  openEditShopifyTrialModal(app: any) {
    this.setState({ showEditShopifyTrialModal: true, appToBeEdited: app._id });
  }

  prettifyDate(dateString: any) {
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    const date = new Date(dateString);
    const month = date.getMonth();
    const day = date.getDate();
    const year = date.getFullYear();
    const dateFormatted = months[month] + ' ' + day + ', ' + year;
    return dateFormatted;
  }

  deleteApp(app: any) {
    const r = confirm(
      'Are you sure you want to delete this app?  This will affect all users who are linked to this app and is not undoable.',
    ); // eslint-disable-line no-undef
    if (r) {
      const updates = {
        deleted: true,
      };
      this.props.actions.app.updateApp(app._id, updates, () => {
        this.fetchData({
          page: this.state.page,
          pageSize: this.state.pageSize,
        });
      });
    }
  }

  undeleteApp(app: any) {
    const r = confirm(
      'Are you sure you want to undelete this app?  This will affect all users who are linked to this app and is not undoable.',
    ); // eslint-disable-line no-undef
    if (r) {
      const updates = {
        deleted: false,
      };
      this.props.actions.app.updateApp(app._id, updates, () => {
        this.fetchData({
          page: this.state.page,
          pageSize: this.state.pageSize,
        });
      });
    }
  }

  quickFix(app: any) {
    const r = confirm(
      'Are you sure you want to change this app?  This will affect all users who are linked to this app.',
    ); // eslint-disable-line no-undef
    if (r) {
      const newChosenOptions = Object.assign({}, app.chosenOptions, {
        socialApp: true,
      });
      const updates = {
        chosenOptions: newChosenOptions,
      };
      this.props.actions.app.updateApp(app._id, updates, () => {
        this.fetchData({
          page: this.state.page,
          pageSize: this.state.pageSize,
        });
      });
    }
  }

  makeAdmin(app: any) {
    const updates = {
      admin: !app.admin,
    };
    this.props.actions.app.updateApp(app._id, updates, () => {
      this.fetchData({ page: this.state.page, pageSize: this.state.pageSize });
    });
  }

  updateTrial() {
    const updates = {
      trialEndDate: moment(this.state.trialEndString).format(),
    };

    this.props.actions.app.updateApp(this.state.appToBeEdited, updates, () => {
      alert('success');
      this.fetchData({ page: this.state.page, pageSize: this.state.pageSize });
      this.setState({ showEditTrialModal: false });
    }); // eslint-disable-line no-undef
  }

  updateUserCount() {
    const updates = {
      activeUsers: this.state.userCountString,
    };

    this.props.actions.app.updateApp(this.state.appToBeEdited, updates, () => {
      alert('success');
      this.fetchData({ page: this.state.page, pageSize: this.state.pageSize });
      this.setState({ showEditUserCountModal: false });
    }); // eslint-disable-line no-undef
  }

  updateShopifyTrial() {
    const updates = {
      shopifyTrialExtraDays: Number(this.state.shopifyTrialEndString),
      needsExtendedShopifyTrial:
        Number(this.state.shopifyTrialEndString) === 0 ? false : true,
    };

    this.props.actions.app.updateApp(this.state.appToBeEdited, updates, () => {
      alert('success');
      this.fetchData({ page: this.state.page, pageSize: this.state.pageSize });
      this.setState({ showEditShopifyTrialModal: false });
    }); // eslint-disable-line no-undef
  }

  setAsPartner(app: any) {
    const updates = {
      partnerApp: true,
    };
    if (app.chosenOptions && app.chosenOptions.shopifyAccessToken) {
      updates.shopifyTrialExtraDays = 365;
      updates.needsExtendedShopifyTrial = true;
    } else {
      updates.trialEndDate = moment().add(365, 'day').format();
    }
    // alert(JSON.stringify(updates));
    this.props.actions.app.updateApp(app._id, updates, () => {
      this.fetchData({ page: this.state.page, pageSize: this.state.pageSize });
    });
  }

  partnerPaywallSkip(app: any) {
    const newChosenOptions = Object.assign({}, app.chosenOptions, {
      partnerPaywallSkip: true,
    });
    const updates = {
      chosenOptions: newChosenOptions,
    };
    // alert(JSON.stringify(updates));
    this.props.actions.app.updateApp(app._id, updates, () => {
      this.fetchData({ page: this.state.page, pageSize: this.state.pageSize });
    });
  }

  preUseApp(app: any) {
    // get the most live and fresh version
    const host = ACTIVE_HOST + '/app/fetchOne';
    const data = {
      appId: app._id,
    };
    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('jwtToken'),
      },
      method: 'post',
      body: JSON.stringify(data),
    };
    fetch(host, options)
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .then(appRes => {
        if (appRes && appRes[0]) {
          this.useApp(appRes[0]);
        } else {
          // alert('Error loading app.');
        }
      })
      .catch(() => {
        // alert('Error loading app.');
      });
  }

  useApp(app: any) {
    app.impersonateMode = true;
    if (
      app.subscriptionPlan === 'instagram' ||
      (app.chosenOptions && app.chosenOptions.socialApp)
    ) {
      this.props.actions.app.useApp(app, this.useAppSocialCallback);
    } else {
      this.props.actions.app.useApp(app, this.useAppCallback);
    }
  }

  useAppCallback(app: any) {
    let goToPaywall = false;
    if (
      app.subscriptionPlan === 'paused' ||
      app.subscriptionPlan === 'unsubscribed' ||
      (!app.monthlyStripeAccountId &&
        !app.shopifyChargeId &&
        !app.partner &&
        app.appTitle !== 'Vintage Founder') ||
      app.needsExtendedShopifyTrial
    ) {
      if (app.chosenOptions && !app.chosenOptions.shopifyAccessToken) {
        const createToday = new Date();
        const trialEndDate = app.trialEndDate;

        const trialDate = Date.parse(trialEndDate);
        const today = Date.parse(createToday);

        if (
          trialDate < today ||
          app.subscriptionPlan === 'paused' ||
          app.subscriptionPlan === 'unsubscribed'
        ) {
          goToPaywall = true;
        }
      } else {
        goToPaywall = true;
      }
      // this.props.history.push('/app/main/paywall');
    }

    if (app.chosenOptions && app.chosenOptions.partnerPaywallSkip) {
      goToPaywall = false;
    }

    if (goToPaywall) {
      this.props.history.push('/app/main/paywall');
    } else {
      this.props.history.push('/app/main/design');
    }

    if (app.partnerApp && !app.acceptedPartnerToS) {
      this.props.history.push('/app/main/partnerToS');
    }

    swal({
      title: 'Warning!',
      text: "Changes made while in Impersonation Mode will update the client's live app.",
      type: 'warning',
      confirmButtonText: 'I understand',
    });
    this.userInstalledCheck(app);
  }

  useAppSocialCallback(app: any) {
    if (
      (!app.monthlyStripeAccountId &&
        !app.shopifyChargeId &&
        !app.partner &&
        app.appTitle !== 'Vintage Founder') ||
      app.needsExtendedShopifyTrial
    ) {
      this.props.history.push('/app/main/paywall');
    } else {
      this.props.history.push('/app/main/shoppableInstagram');
    }
    swal({
      title: 'Warning!',
      text: "Changes made while in Impersonation Mode will update the client's live app.",
      type: 'warning',
      confirmButtonText: 'I understand',
    });
  }

  copyBuildScript(app: any) {
    //
    if (app.chosenOptions.storeUrl === undefined) {
      app.chosenOptions.storeUrl = '';
    }
    let media0 = '';
    if (
      app.chosenOptions.customPages &&
      app.chosenOptions.customPages[0] &&
      app.chosenOptions.customPages[0].media
    ) {
      media0 = app.chosenOptions.customPages[0].media;
    }

    let media1 = '';
    if (
      app.chosenOptions.customPages &&
      app.chosenOptions.customPages[1] &&
      app.chosenOptions.customPages[1].media
    ) {
      media1 = app.chosenOptions.customPages[1].media;
    }

    let media2 = '';
    if (
      app.chosenOptions.customPages &&
      app.chosenOptions.customPages[2] &&
      app.chosenOptions.customPages[2].media
    ) {
      media2 = app.chosenOptions.customPages[2].media;
    }

    let media3 = '';
    if (
      app.chosenOptions.customPages &&
      app.chosenOptions.customPages[3] &&
      app.chosenOptions.customPages[3].media
    ) {
      media3 = app.chosenOptions.customPages[3].media;
    }

    let media4 = '';
    if (
      app.chosenOptions.customPages &&
      app.chosenOptions.customPages[4] &&
      app.chosenOptions.customPages[4].media
    ) {
      media4 = app.chosenOptions.customPages[4].media;
    }

    const text =
      'sh theScript.sh ' +
      app.ownerId +
      " '" +
      app.chosenOptions.title +
      "' " +
      app.chosenOptions.shopify +
      ' ' +
      app.chosenOptions.bigcommerce +
      " '" +
      app.chosenOptions.iconUrl +
      "' '" +
      app.chosenOptions.storeUrl +
      "' " +
      "false '" +
      'com.sandbox.' +
      app.packageId +
      "' '" +
      app.googleSignInId +
      "' '" +
      app.uaProdKey +
      "' '" +
      app.uaProdSec +
      "' '" +
      media0 +
      "' '" +
      media1 +
      "' '" +
      media2 +
      "' '" +
      media3 +
      "' '" +
      media4 +
      "' '" +
      app.chosenOptions.splashBackground +
      "' " + // launch screen image
      "'#ffffff' " + // launch screen background color
      app._id +
      " '1172424636124298' '" + // facebook app id for login
      app.chosenOptions.title +
      "' " + // facebook app name for login
      "'sbcappname' " + // deep link url
      'true ' + // should show login
      'true ' + // should show search
      "''"; // merchant id for ios

    //
    this.createFontScript(app);
    // alert(text); // eslint-disable-line
    prompt('Copy to clipboard: Ctrl+C', text);
  }

  consoleLogApp(app: any) {}

  createFontScript(app: any) {
    let text =
      '#!/usr/bin/env bash' +
      '\n\n' +
      'SCRIPTPATH=$(dirname $0)' +
      '\n' +
      'FONTFILENAMERAW=""' +
      '\n' +
      'FONTFILENAME=""' +
      '\n\n';
    if (app.chosenOptions.mainFontFile) {
      text +=
        'curl ' +
        app.chosenOptions.mainFontFile +
        ' > $SCRIPTPATH/downloadedFonts/font.ttf\n' +
        'sleep 3\n' +
        'FONTFILENAMERAW=$(mdls -name com_apple_ats_name_family $SCRIPTPATH/downloadedFonts/font.ttf)\n' +
        'echo "$FONTFILENAMERAW"\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/com_apple_ats_name_family/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/=/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/\\(/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/\\"/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/\\"/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/\\)/}\n' +
        'FONTFILENAME=$(echo $FONTFILENAMERAW)\n' +
        'echo "$FONTFILENAME"\n' +
        'cp $SCRIPTPATH/downloadedFonts/font.ttf $SCRIPTPATH/android/app/src/main/assets/fonts/"$FONTFILENAME".ttf\n' +
        'cp $SCRIPTPATH/downloadedFonts/font.ttf $SCRIPTPATH/ios/Fonts/"$FONTFILENAME".ttf\n' +
        'rm $SCRIPTPATH/downloadedFonts/font.ttf\n' +
        'sed -i -e "s/_FONTNAME/$FONTFILENAME/" $SCRIPTPATH/components/visibleOptions.js\n\n';
    }
    if (app.chosenOptions.buttonFontFile) {
      text +=
        'curl ' +
        app.chosenOptions.buttonFontFile +
        ' > $SCRIPTPATH/downloadedFonts/font.ttf\n' +
        'sleep 3\n' +
        'FONTFILENAMERAW=$(mdls -name com_apple_ats_name_family $SCRIPTPATH/downloadedFonts/font.ttf)\n' +
        'echo "$FONTFILENAMERAW"\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/com_apple_ats_name_family/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/=/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/\\(/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/\\"/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/\\"/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/\\)/}\n' +
        'FONTFILENAME=$(echo $FONTFILENAMERAW)\n' +
        'echo "$FONTFILENAME"\n' +
        'cp $SCRIPTPATH/downloadedFonts/font.ttf $SCRIPTPATH/android/app/src/main/assets/fonts/"$FONTFILENAME".ttf\n' +
        'cp $SCRIPTPATH/downloadedFonts/font.ttf $SCRIPTPATH/ios/Fonts/"$FONTFILENAME".ttf\n' +
        'rm $SCRIPTPATH/downloadedFonts/font.ttf\n' +
        'sed -i -e "s/_FONTNAME/$FONTFILENAME/" $SCRIPTPATH/components/visibleOptions.js\n\n';
    }
    if (app.chosenOptions.textFontFile) {
      text +=
        'curl ' +
        app.chosenOptions.textFontFile +
        ' > $SCRIPTPATH/downloadedFonts/font.ttf\n' +
        'sleep 3\n' +
        'FONTFILENAMERAW=$(mdls -name com_apple_ats_name_family $SCRIPTPATH/downloadedFonts/font.ttf)\n' +
        'echo "$FONTFILENAMERAW"\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/com_apple_ats_name_family/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/=/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/\\(/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/\\"/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/\\"/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/\\)/}\n' +
        'FONTFILENAME=$(echo $FONTFILENAMERAW)\n' +
        'echo "$FONTFILENAME"\n' +
        'cp $SCRIPTPATH/downloadedFonts/font.ttf $SCRIPTPATH/android/app/src/main/assets/fonts/"$FONTFILENAME".ttf\n' +
        'cp $SCRIPTPATH/downloadedFonts/font.ttf $SCRIPTPATH/ios/Fonts/"$FONTFILENAME".ttf\n' +
        'rm $SCRIPTPATH/downloadedFonts/font.ttf\n' +
        'sed -i -e "s/_FONTNAME/$FONTFILENAME/" $SCRIPTPATH/components/visibleOptions.js\n\n';
    }
    if (app.chosenOptions.titleFontFile) {
      text +=
        'curl ' +
        app.chosenOptions.titleFontFile +
        ' > $SCRIPTPATH/downloadedFonts/font.ttf\n' +
        'sleep 3\n' +
        'FONTFILENAMERAW=$(mdls -name com_apple_ats_name_family $SCRIPTPATH/downloadedFonts/font.ttf)\n' +
        'echo "$FONTFILENAMERAW"\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/com_apple_ats_name_family/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/=/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/\\(/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/\\"/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/\\"/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/\\)/}\n' +
        'FONTFILENAME=$(echo $FONTFILENAMERAW)\n' +
        'echo "$FONTFILENAME"\n' +
        'cp $SCRIPTPATH/downloadedFonts/font.ttf $SCRIPTPATH/android/app/src/main/assets/fonts/"$FONTFILENAME".ttf\n' +
        'cp $SCRIPTPATH/downloadedFonts/font.ttf $SCRIPTPATH/ios/Fonts/"$FONTFILENAME".ttf\n' +
        'rm $SCRIPTPATH/downloadedFonts/font.ttf\n' +
        'sed -i -e "s/_FONTNAME/$FONTFILENAME/" $SCRIPTPATH/components/visibleOptions.js\n\n';
    }
    if (app.chosenOptions.categoryFontFile) {
      text +=
        'curl ' +
        app.chosenOptions.categoryFontFile +
        ' > $SCRIPTPATH/downloadedFonts/font.ttf\n' +
        'sleep 3\n' +
        'FONTFILENAMERAW=$(mdls -name com_apple_ats_name_family $SCRIPTPATH/downloadedFonts/font.ttf)\n' +
        'echo "$FONTFILENAMERAW"\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/com_apple_ats_name_family/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/=/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/\\(/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/\\"/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/\\"/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/\\)/}\n' +
        'FONTFILENAME=$(echo $FONTFILENAMERAW)\n' +
        'echo "$FONTFILENAME"\n' +
        'cp $SCRIPTPATH/downloadedFonts/font.ttf $SCRIPTPATH/android/app/src/main/assets/fonts/"$FONTFILENAME".ttf\n' +
        'cp $SCRIPTPATH/downloadedFonts/font.ttf $SCRIPTPATH/ios/Fonts/"$FONTFILENAME".ttf\n' +
        'rm $SCRIPTPATH/downloadedFonts/font.ttf\n' +
        'sed -i -e "s/_FONTNAME/$FONTFILENAME/" $SCRIPTPATH/components/visibleOptions.js\n\n';
    }
    if (app.chosenOptions.customPageFontFile) {
      text +=
        'curl ' +
        app.chosenOptions.customPageFontFile +
        ' > $SCRIPTPATH/downloadedFonts/font.ttf\n' +
        'sleep 3\n' +
        'FONTFILENAMERAW=$(mdls -name com_apple_ats_name_family $SCRIPTPATH/downloadedFonts/font.ttf)\n' +
        'echo "$FONTFILENAMERAW"\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/com_apple_ats_name_family/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/=/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/\\(/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/\\"/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/\\"/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/\\)/}\n' +
        'FONTFILENAME=$(echo $FONTFILENAMERAW)\n' +
        'echo "$FONTFILENAME"\n' +
        'cp $SCRIPTPATH/downloadedFonts/font.ttf $SCRIPTPATH/android/app/src/main/assets/fonts/"$FONTFILENAME".ttf\n' +
        'cp $SCRIPTPATH/downloadedFonts/font.ttf $SCRIPTPATH/ios/Fonts/"$FONTFILENAME".ttf\n' +
        'rm $SCRIPTPATH/downloadedFonts/font.ttf\n' +
        'sed -i -e "s/_FONTNAME/$FONTFILENAME/" $SCRIPTPATH/components/visibleOptions.js\n\n';
    }
    if (app.chosenOptions.homeItemFontFile) {
      text +=
        'curl ' +
        app.chosenOptions.homeItemFontFile +
        ' > $SCRIPTPATH/downloadedFonts/font.ttf\n' +
        'sleep 3\n' +
        'FONTFILENAMERAW=$(mdls -name com_apple_ats_name_family $SCRIPTPATH/downloadedFonts/font.ttf)\n' +
        'echo "$FONTFILENAMERAW"\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/com_apple_ats_name_family/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/=/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/\\(/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/\\"/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/\\"/}\n' +
        'FONTFILENAMERAW=${FONTFILENAMERAW/\\)/}\n' +
        'FONTFILENAME=$(echo $FONTFILENAMERAW)\n' +
        'echo "$FONTFILENAME"\n' +
        'cp $SCRIPTPATH/downloadedFonts/font.ttf $SCRIPTPATH/android/app/src/main/assets/fonts/"$FONTFILENAME".ttf\n' +
        'cp $SCRIPTPATH/downloadedFonts/font.ttf $SCRIPTPATH/ios/Fonts/"$FONTFILENAME".ttf\n' +
        'rm $SCRIPTPATH/downloadedFonts/font.ttf\n' +
        'sed -i -e "s/_FONTNAME/$FONTFILENAME/" $SCRIPTPATH/components/visibleOptions.js\n\n';
    }
    if (app.chosenOptions.homeCategories) {
      for (let i = 0; i < app.chosenOptions.homeCategories.length; i++) {
        // text += 'category ' + i + JSON.stringify(app.chosenOptions.homeCategories[i]) + '\n';
        if (
          app.chosenOptions.homeCategories &&
          app.chosenOptions.homeCategories[i] &&
          app.chosenOptions.homeCategories[i].fontFile
        ) {
          text +=
            'curl ' +
            app.chosenOptions.homeCategories[i].fontFile +
            ' > $SCRIPTPATH/downloadedFonts/font.ttf\n' +
            'sleep 3\n' +
            'FONTFILENAMERAW=$(mdls -name com_apple_ats_name_family $SCRIPTPATH/downloadedFonts/font.ttf)\n' +
            'echo "$FONTFILENAMERAW"\n' +
            'FONTFILENAMERAW=${FONTFILENAMERAW/com_apple_ats_name_family/}\n' +
            'FONTFILENAMERAW=${FONTFILENAMERAW/=/}\n' +
            'FONTFILENAMERAW=${FONTFILENAMERAW/\\(/}\n' +
            'FONTFILENAMERAW=${FONTFILENAMERAW/\\"/}\n' +
            'FONTFILENAMERAW=${FONTFILENAMERAW/\\"/}\n' +
            'FONTFILENAMERAW=${FONTFILENAMERAW/\\)/}\n' +
            'FONTFILENAME=$(echo $FONTFILENAMERAW)\n' +
            'echo "$FONTFILENAME"\n' +
            'cp $SCRIPTPATH/downloadedFonts/font.ttf $SCRIPTPATH/android/app/src/main/assets/fonts/"$FONTFILENAME".ttf\n' +
            'cp $SCRIPTPATH/downloadedFonts/font.ttf $SCRIPTPATH/ios/Fonts/"$FONTFILENAME".ttf\n' +
            'rm $SCRIPTPATH/downloadedFonts/font.ttf\n' +
            'sed -i -e "s/_FONTNAME/$FONTFILENAME/" $SCRIPTPATH/components/visibleOptions.js\n\n';
        }
      }
    }
    if (app.chosenOptions.homeItems) {
      for (let i = 0; i < app.chosenOptions.homeItems.length; i++) {
        // text += 'item ' + i + ' ' + JSON.stringify(app.chosenOptions.homeItems[i]) + '\n';
        if (
          app.chosenOptions.homeItems[i] &&
          app.chosenOptions.homeItems[i].fontFile
        ) {
          text +=
            'curl ' +
            app.chosenOptions.homeItems[i].fontFile +
            ' > $SCRIPTPATH/downloadedFonts/font.ttf\n' +
            'sleep 3\n' +
            'FONTFILENAMERAW=$(mdls -name com_apple_ats_name_family $SCRIPTPATH/downloadedFonts/font.ttf)\n' +
            'echo "$FONTFILENAMERAW"\n' +
            'FONTFILENAMERAW=${FONTFILENAMERAW/com_apple_ats_name_family/}\n' +
            'FONTFILENAMERAW=${FONTFILENAMERAW/=/}\n' +
            'FONTFILENAMERAW=${FONTFILENAMERAW/\\(/}\n' +
            'FONTFILENAMERAW=${FONTFILENAMERAW/\\"/}\n' +
            'FONTFILENAMERAW=${FONTFILENAMERAW/\\"/}\n' +
            'FONTFILENAMERAW=${FONTFILENAMERAW/\\)/}\n' +
            'FONTFILENAME=$(echo $FONTFILENAMERAW)\n' +
            'echo "$FONTFILENAME"\n' +
            'cp $SCRIPTPATH/downloadedFonts/font.ttf $SCRIPTPATH/android/app/src/main/assets/fonts/"$FONTFILENAME".ttf\n' +
            'cp $SCRIPTPATH/downloadedFonts/font.ttf $SCRIPTPATH/ios/Fonts/"$FONTFILENAME".ttf\n' +
            'rm $SCRIPTPATH/downloadedFonts/font.ttf\n' +
            'sed -i -e "s/_FONTNAME/$FONTFILENAME/" $SCRIPTPATH/components/visibleOptions.js\n\n';
        }
      }
    }
    if (app.chosenOptions.homeMarquees) {
      for (let i = 0; i < app.chosenOptions.homeMarquees.length; i++) {
        // text += 'marquee ' + i + JSON.stringify(app.chosenOptions.homeMarquees[i]) + '\n';
        if (
          app.chosenOptions.homeMarquees[i] &&
          app.chosenOptions.homeMarquees[i].fontFile
        ) {
          text +=
            'curl ' +
            app.chosenOptions.homeMarquees[i].fontFile +
            ' > $SCRIPTPATH/downloadedFonts/font.ttf\n' +
            'sleep 3\n' +
            'FONTFILENAMERAW=$(mdls -name com_apple_ats_name_family $SCRIPTPATH/downloadedFonts/font.ttf)\n' +
            'echo "$FONTFILENAMERAW"\n' +
            'FONTFILENAMERAW=${FONTFILENAMERAW/com_apple_ats_name_family/}\n' +
            'FONTFILENAMERAW=${FONTFILENAMERAW/=/}\n' +
            'FONTFILENAMERAW=${FONTFILENAMERAW/\\(/}\n' +
            'FONTFILENAMERAW=${FONTFILENAMERAW/\\"/}\n' +
            'FONTFILENAMERAW=${FONTFILENAMERAW/\\"/}\n' +
            'FONTFILENAMERAW=${FONTFILENAMERAW/\\)/}\n' +
            'FONTFILENAME=$(echo $FONTFILENAMERAW)\n' +
            'echo "$FONTFILENAME"\n' +
            'cp $SCRIPTPATH/downloadedFonts/font.ttf $SCRIPTPATH/android/app/src/main/assets/fonts/"$FONTFILENAME".ttf\n' +
            'cp $SCRIPTPATH/downloadedFonts/font.ttf $SCRIPTPATH/ios/Fonts/"$FONTFILENAME".ttf\n' +
            'rm $SCRIPTPATH/downloadedFonts/font.ttf\n' +
            'sed -i -e "s/_FONTNAME/$FONTFILENAME/" $SCRIPTPATH/components/visibleOptions.js\n\n';
        }
      }
    }
    if (app.chosenOptions.homeVideos) {
      for (let i = 0; i < app.chosenOptions.homeVideos.length; i++) {
        // text += 'video ' + i + JSON.stringify(app.chosenOptions.homeVideos[i]) + '\n';
        if (
          app.chosenOptions.homeVideos[i] &&
          app.chosenOptions.homeVideos[i].fontFile
        ) {
          text +=
            'curl ' +
            app.chosenOptions.homeVideos[i].fontFile +
            ' > $SCRIPTPATH/downloadedFonts/font.ttf\n' +
            'sleep 3\n' +
            'FONTFILENAMERAW=$(mdls -name com_apple_ats_name_family $SCRIPTPATH/downloadedFonts/font.ttf)\n' +
            'echo "$FONTFILENAMERAW"\n' +
            'FONTFILENAMERAW=${FONTFILENAMERAW/com_apple_ats_name_family/}\n' +
            'FONTFILENAMERAW=${FONTFILENAMERAW/=/}\n' +
            'FONTFILENAMERAW=${FONTFILENAMERAW/\\(/}\n' +
            'FONTFILENAMERAW=${FONTFILENAMERAW/\\"/}\n' +
            'FONTFILENAMERAW=${FONTFILENAMERAW/\\"/}\n' +
            'FONTFILENAMERAW=${FONTFILENAMERAW/\\)/}\n' +
            'FONTFILENAME=$(echo $FONTFILENAMERAW)\n' +
            'echo "$FONTFILENAME"\n' +
            'cp $SCRIPTPATH/downloadedFonts/font.ttf $SCRIPTPATH/android/app/src/main/assets/fonts/"$FONTFILENAME".ttf\n' +
            'cp $SCRIPTPATH/downloadedFonts/font.ttf $SCRIPTPATH/ios/Fonts/"$FONTFILENAME".ttf\n' +
            'rm $SCRIPTPATH/downloadedFonts/font.ttf\n' +
            'sed -i -e "s/_FONTNAME/$FONTFILENAME/" $SCRIPTPATH/components/visibleOptions.js\n\n';
        }
      }
    }

    const element = document.createElement('a'); // eslint-disable-line
    element.setAttribute(
      'href',
      'data:text/plain;charset=utf-8,' + encodeURIComponent(text),
    );
    element.setAttribute('download', 'fontScript.sh');

    element.style.display = 'none';
    document.body.appendChild(element); // eslint-disable-line

    element.click();

    document.body.removeChild(element); // eslint-disable-line
  }

  getBillingInfo(app: any) {
    this.props.actions.app.checkShopifyChargeId(
      app.shopifyChargeId,
      app.shopifyChargeType,
      app.chosenOptions.shopifyAccessToken,
      app.chosenOptions.shopifyStoreName,
      (results: any) => {
        if (results && results.status && results.status === 'declined') {
        } else if (results && results.status && results.status === 'active') {
          if (results.return_url && results.return_url.indexOf('yearly') > -1) {
            const aYearFrom = new Date(results.created_at);
            aYearFrom.setFullYear(aYearFrom.getFullYear() + 1);
            const billingOverviewInfo = {
              yearly: true,
              dateSince: results.created_at,
              currentPlan: results.name,
              accountStatus: results.status,
              nextBillDate: aYearFrom,
              test: results.test,
            };
            this.setState({ billingOverviewInfo, showBillingModal: true });
          } else {
            const billingOverviewInfo = {
              yearly: false,
              dateSince: results.activated_on,
              currentPlan: results.name,
              accountStatus: results.status,
              nextBillDate: results.billing_on,
              test: results.test,
            };
            this.setState({ billingOverviewInfo, showBillingModal: true });
          }
        } else {
        }
      },
    );
  }

  openEditDeploymentStatusModal(app: any) {
    this.setState({
      showAppOptionsModal: false,
      showEditDeploymentStatusModal: true,
      appToBeEdited: app._id,
      appToBeEditedOptions: app.chosenOptions,
      deploymentStatusStringANDROID: app.googleProgress,
      deploymentStatusStringIOS: app.appleProgress,
    });
  }

  openEditCustomerSupportTierModal(app: any) {
    this.setState({
      showAppOptionsModal: false,
      showEditCustomerSupportTierModal: true,
      appToBeEdited: app._id,
      fullAppToBeEdited: app,
      appToBeEditedOptions: app.chosenOptions,
      customerSupportPlanToBeEdited: app.customerSupportPlan,
      customerSupportCustomPriceToBeEdited: app.customerSupportCustomPrice,
    });
  }

  openEditPackageIdModal(app: any) {
    this.setState({
      showAppOptionsModal: false,
      showEditPackageIdModal: true,
      appToBeEdited: app._id,
      appToBeEditedOptions: app.chosenOptions,
      packageIdString: app.packageId,
    });
  }

  openEditUserCountModal(app: any) {
    this.setState({
      showAppOptionsModal: false,
      showEditUserCountModal: true,
      appToBeEdited: app._id,
      appToBeEditedOptions: app.chosenOptions,
      userCountString: app.activeUsers,
    });
  }

  openEditSubscriptionModal(app: any) {
    this.setState({
      showAppOptionsModal: false,
      showEditSubscriptionModal: true,
      appToBeEdited: app._id,
      fullAppToBeEdited: app,
      appToBeEditedOptions: app.chosenOptions,
      packageIdString: app.packageId,
    });
  }

  openEditStoreLinkModal(app: any) {
    let androidVersionString = '';
    let appleVersionString = '';
    if (app.chosenOptions.versionApp) {
      androidVersionString = app.chosenOptions.versionApp.android.version;
      appleVersionString = app.chosenOptions.versionApp.ios.version;
    }
    this.setState({
      showAppStoreModal: true,
      appToBeEdited: app._id,
      appToBeEditedOptions: app.chosenOptions,
      playStoreString: app.googlePlay,
      itunesString: app.itunesStore,
      androidVersionString,
      appleVersionString,
    });
  }

  updatePackageIdState(event: any) {
    const packageIdString = event.target.value;
    return this.setState({ packageIdString });
  }

  updateSubscriptionPlanState(event: any) {
    const subscriptionPlanString = event.target.value;
    return this.setState({ subscriptionPlanString });
  }

  updateDeploymentStatusState(event: any) {
    if (event.target.name === 'ios') {
      return this.setState({ deploymentStatusStringIOS: event.target.value });
    } else if (event.target.name === 'android') {
      return this.setState({
        deploymentStatusStringANDROID: event.target.value,
      });
    }
  }

  updateCustomerSupportTierState(event: any) {
    // alert(event);
    let price = this.state.customerSupportCustomPriceToBeEdited;
    if (event !== 'enterprise') {
      price = 0;
    }
    this.setState({
      customerSupportPlanToBeEdited: event,
      customerSupportCustomPriceToBeEdited: price,
    });
  }

  updateCustomerSupportCustomPriceState(event: any) {
    return this.setState({
      customerSupportCustomPriceToBeEdited: event.target.value,
    });
  }

  updateStoreLinkState(event: any) {
    if (event.target.name === 'itunes') {
      return this.setState({ itunesString: event.target.value });
    } else if (event.target.name === 'playStore') {
      return this.setState({ playStoreString: event.target.value });
    } else if (event.target.name === 'appleVersionString') {
      return this.setState({ appleVersionString: event.target.value });
    } else if (event.target.name === 'androidVersionString') {
      return this.setState({ androidVersionString: event.target.value });
    }
  }

  updateTrialEndState(event: any) {
    return this.setState({ trialEndString: event.target.value });
  }

  updateUserCountState(event: any) {
    return this.setState({ userCountString: event.target.value });
  }

  updateShopifyTrialEndState(event: any) {
    return this.setState({ shopifyTrialEndString: event.target.value });
  }

  updatePackageId() {
    const updates = {
      packageId: this.state.packageIdString,
    };
    // alert(JSON.stringify(updates));
    // alert(this.state.planString);
    this.props.actions.app.updateApp(
      this.state.appToBeEdited,
      updates,
      (updates: any, app: any) => {
        alert('success ' + app.packageId);
        this.fetchData({
          page: this.state.page,
          pageSize: this.state.pageSize,
        });
        this.setState({ showEditPackageIdModal: false });
      },
    ); // eslint-disable-line
  }

  updateSubscriptionPlan() {
    // const chosenOptionsUpdated = JSON.parse(JSON.stringify(this.state.fullAppToBeEdited.chosenOptions));
    //
    // chosenOptionsUpdated.bcStoreHash = this.state.subscriptionPlanString;
    // const updates = {
    //   chosenOptions: chosenOptionsUpdated
    // };
    const updates = {
      subscriptionPlan: this.state.subscriptionPlanString,
    };
    // alert(JSON.stringify(updates));
    // alert(this.state.planString);
    this.props.actions.app.updateApp(
      this.state.appToBeEdited,
      updates,
      (updates: any, app: any) => {
        alert('success ' + app.subscriptionPlan);
        this.fetchData({
          page: this.state.page,
          pageSize: this.state.pageSize,
        });
        this.setState({ showEditSubscriptionModal: false });
      },
    ); // eslint-disable-line
  }

  updateDeploymentStatus() {
    // const chosenOptionsUpdated = JSON.parse(JSON.stringify(this.state.fullAppToBeEdited.chosenOptions));
    //
    // chosenOptionsUpdated.bcStoreHash = this.state.subscriptionPlanString;
    // const updates = {
    //   chosenOptions: chosenOptionsUpdated
    // };
    const updates = {
      appleProgress: this.state.deploymentStatusStringIOS,
      googleProgress: this.state.deploymentStatusStringANDROID,
    };
    // alert(JSON.stringify(updates));
    // alert(this.state.planString);
    this.props.actions.app.updateApp(
      this.state.appToBeEdited,
      updates,
      (updates: any, app: any) => {
        alert('success ');
        this.fetchData({
          page: this.state.page,
          pageSize: this.state.pageSize,
        });
        this.setState({ showEditDeploymentStatusModal: false });
      },
    ); // eslint-disable-line
  }

  prePreUpdateCustomerSupportTier() {
    // calculate pro-rate
    const app = this.state.fullAppToBeEdited;
    const plan = this.state.customerSupportPlanToBeEdited;
    let price = this.state.customerSupportCustomPriceToBeEdited;
    if (plan === 'advanced') {
      price = 249;
    } else if (plan === 'basic') {
      price = 0;
    }

    if (
      (app.dateSubscribed || app.lastBilled) &&
      app.subscriptionPlan !== 'trial' &&
      app.monthlyStripeAccountId
    ) {
      const dateLastBilled = app.lastBilled;
      const dateSubscribed = app.dateSubscribed;
      const dateTrialEnds = app.trialEndDate;
      let neverBeenBilled = false;
      const billMonthly = !app.yearlySubscription;
      const billYearly = app.yearlySubscription;

      let dateToCheck = dateLastBilled;

      if (!dateToCheck) {
        if (dateSubscribed) {
          dateToCheck = dateSubscribed;
        } else if (dateTrialEnds) {
          neverBeenBilled = true;
          dateToCheck = dateTrialEnds;
        } else {
          neverBeenBilled = true;
          dateToCheck = Date.now();
        }
      }

      // TODO: if testing comment line below
      const dateToCheckPlusOneMonth = moment(dateToCheck).add(1, 'months');
      const dateToCheckPlusOneYear = moment(dateToCheck).add(1, 'years');
      if (neverBeenBilled) {
      } else if (billMonthly) {
        dateToCheck = dateToCheckPlusOneMonth;
      } else if (billYearly) {
        dateToCheck = dateToCheckPlusOneYear;
      }

      const now = moment();
      const daysBetweenNowAndBilling = dateToCheck.diff(now, 'days') + 1;

      if (daysBetweenNowAndBilling > 0) {
        const proratedAmount = (price / 30) * daysBetweenNowAndBilling;

        this.setState({
          showEditCustomerSupportTierModal: false,
          showCustomerConfirmationSwal: true,
          customerConfirmationSwalNumberOfDays: daysBetweenNowAndBilling,
          customerConfirmationSwalPrice: proratedAmount,
          customerConfirmationSwalPlan: plan,
          customerConfirmationSwalBillDate: dateToCheck,
          customerConfirmationSwalPlatform: 'stripe',
        });
      }
    } else if (app.shopifyChargeId) {
      this.props.actions.app.checkShopifyChargeId(
        app.shopifyChargeId,
        app.shopifyChargeType,
        app.chosenOptions.shopifyAccessToken,
        app.chosenOptions.shopifyStoreURL.replace('.myshopify.com', ''),
        (results: any) => {
          if (results && results.status) {
            const nextBillDate = moment(results.billing_on);
            const now = moment();
            const daysBetweenNowAndBilling = nextBillDate.diff(now, 'days') + 1;

            if (daysBetweenNowAndBilling > 0) {
              const proratedAmount = (price / 30) * daysBetweenNowAndBilling;

              this.setState({
                showEditCustomerSupportTierModal: false,
                showCustomerConfirmationSwal: true,
                customerConfirmationSwalNumberOfDays: daysBetweenNowAndBilling,
                customerConfirmationSwalPrice: proratedAmount,
                customerConfirmationSwalPlan: plan,
                customerConfirmationSwalBillDate: nextBillDate,
                customerConfirmationSwalPlatform: 'shopify',
              });
            }
          } else {
            if (results.fullError) {
              this.setState({
                loadingShopifyInfo: false,
                shopifyInfoError: 'Error from Shopify: ' + results.fullError,
                shopifyClearTokens: results.clearAuthTokens,
              });
            }
          }
        },
      );
    }
  }

  preUpdateCustomerSupportTier() {
    // do the charge
    const app = this.state.fullAppToBeEdited;
    const plan = this.state.customerSupportPlanToBeEdited;
    const host2 =
      hosts.ACTIVE_HOST + '/payment/immediateProratedCustomerSupportCharge';
    const data2 = {
      price: this.state.customerSupportCustomPriceToBeEdited,
      plan: plan,
      appId: this.state.appToBeEdited,
      platform: this.state.customerConfirmationSwalPlatform,
      billDate: this.state.customerConfirmationSwalBillDate,
    };
    const options2 = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        // Authorization: 'Bearer ' + localStorage.getItem('jwtToken')
      },
      method: 'post',
      body: JSON.stringify(data2),
    };

    fetch(host2, options2)
      .then(response => {
        // eslint-disable-line
        return response.json();
      })
      .then(results2 => {
        if (results2.success) {
          this.updateCustomerSupportTier();
        } else {
          if (results2.errorType && results2.errorMessage)
            alert('"' + results2.errorType + '" ' + results2.errorMessage);
        }
        this.setState({ showCustomerConfirmationSwal: false });
      })
      .catch(error => {
        // alert('Error creating and assigning app');
        throw error;
      });
  }

  updateCustomerSupportTier() {
    // const chosenOptionsUpdated = JSON.parse(JSON.stringify(this.state.fullAppToBeEdited.chosenOptions));
    //
    // chosenOptionsUpdated.bcStoreHash = this.state.subscriptionPlanString;
    // const updates = {
    //   chosenOptions: chosenOptionsUpdated
    // };
    const updates = {
      customerSupportPlan: this.state.customerSupportPlanToBeEdited,
      customerSupportCustomPrice: Number(
        this.state.customerSupportCustomPriceToBeEdited,
      ),
    };
    // alert(JSON.stringify(updates));
    // alert(this.state.planString);
    this.props.actions.app.updateApp(
      this.state.appToBeEdited,
      updates,
      (updates: any, app: any) => {
        alert('success ');
        this.fetchData({
          page: this.state.page,
          pageSize: this.state.pageSize,
        });
        this.setState({ showEditCustomerSupportTierModal: false });
      },
    ); // eslint-disable-line
  }

  updateStoreLinks() {
    const updates = {
      googlePlay: this.state.playStoreString,
      itunesStore: this.state.itunesString,
    };

    const chosenOptionsUpdated = JSON.parse(
      JSON.stringify(this.state.appToBeEditedOptions),
    );
    const versionApp = {
      ios: {
        version: this.state.appleVersionString,
        url: this.state.itunesString,
      },
      android: {
        version: this.state.androidVersionString,
        url: this.state.playStoreString,
      },
    };

    chosenOptionsUpdated.versionApp = versionApp;
    updates.chosenOptions = chosenOptionsUpdated;
    // alert(JSON.stringify(updates));
    // alert(this.state.planString);
    this.props.actions.app.updateApp(
      this.state.appToBeEdited,
      updates,
      (updates: any, app: any) => {
        alert('success ' + app.googlePlay + ' ' + app.itunesStore);
        this.fetchData({
          page: this.state.page,
          pageSize: this.state.pageSize,
        });
        this.setState({ showAppStoreModal: false });
      },
    ); // eslint-disable-line
  }

  updateTrial() {
    const updates = {
      trialEndDate: moment(this.state.trialEndString).format(),
    };

    this.props.actions.app.updateApp(this.state.appToBeEdited, updates, () => {
      alert('success');
      this.fetchData({ page: this.state.page, pageSize: this.state.pageSize });
      this.setState({ showEditTrialModal: false });
    }); // eslint-disable-line no-undef
  }

  updateUserCount() {
    const updates = {
      activeUsers: this.state.userCountString,
    };

    this.props.actions.app.updateApp(this.state.appToBeEdited, updates, () => {
      alert('success');
      this.fetchData({ page: this.state.page, pageSize: this.state.pageSize });
      this.setState({ showEditUserCountModal: false });
    }); // eslint-disable-line no-undef
  }

  updateShopifyTrial() {
    const updates = {
      shopifyTrialExtraDays: Number(this.state.shopifyTrialEndString),
      needsExtendedShopifyTrial:
        Number(this.state.shopifyTrialEndString) === 0 ? false : true,
    };

    this.props.actions.app.updateApp(this.state.appToBeEdited, updates, () => {
      alert('success');
      this.fetchData({ page: this.state.page, pageSize: this.state.pageSize });
      this.setState({ showEditShopifyTrialModal: false });
    }); // eslint-disable-line no-undef
  }

  setAppForPreview(app: any, bool: any) {
    const updates = { superAdminPreviewApp: app._id };
    if (!bool) {
      updates.superAdminPreviewApp = '';
    }
    // alert(JSON.stringify(updates));
    this.props.actions.user.updateUser(this.props.user._id, updates, () => {
      // lazy refresh
      this.fetchData({ page: this.state.page, pageSize: this.state.pageSize });
    });
  }

  addToWorking(app: any) {
    let superAdminWorkingAppsNew = [];

    if (this.props.user.superAdminWorkingApps) {
      superAdminWorkingAppsNew = JSON.parse(
        JSON.stringify(this.props.user.superAdminWorkingApps),
      );
    }
    let foundIndex = -1;
    for (let i = 0; i < superAdminWorkingAppsNew.length; i++) {
      if (superAdminWorkingAppsNew[i] === app._id) {
        foundIndex = i;
      }
    }
    if (foundIndex === -1) {
      superAdminWorkingAppsNew.push(app._id);
    } else {
      superAdminWorkingAppsNew.splice(foundIndex, 1);
    }
    const updates = { superAdminWorkingApps: superAdminWorkingAppsNew };

    // alert(JSON.stringify(updates));
    this.props.actions.user.updateUser(this.props.user._id, updates, () => {
      // lazy refresh
      this.fetchData({ page: this.state.page, pageSize: this.state.pageSize });
    });
  }

  constructOptionsButton(app: any) {
    // const menuPopover = (
    //   <Popover id="popover-positioned-right" title={app.appTitle}>
    //     {/* <Dropdown.Item bsStyle='primary' onClick={() => this.goToDashboard(app)}>Dashboard</Dropdown.Item>
    //     <Dropdown.Item bsStyle='primary' onClick={() => this.goToPayments(app)}>Payment Setup</Dropdown.Item>
    //     <Dropdown.Item bsStyle='primary' onClick={() => this.getLinkCode(app)}>Get Link Code</Dropdown.Item>
    //     <Dropdown.Item bsStyle='primary' onClick={() => this.openEditAppStatusModal(app)}>Update App Status</Dropdown.Item>
    //     <Dropdown.Item bsStyle='primary' onClick={() => this.openEditSubModal(app)}>Update Subscription</Dropdown.Item>
    //     <Dropdown.Item bsStyle='primary' onClick={() => this.openReleaseModal(app)}>Update Release Form</Dropdown.Item>
    //     <Dropdown.Item bsStyle='primary' onClick={() => this.openEditTrialModal(app)}>Update Trial End</Dropdown.Item>
    //     <Dropdown.Item bsStyle='primary' onClick={() => this.openNextBillDateModal(app)}>Update Next Bill Date</Dropdown.Item>
    //     {app.archived ? <Dropdown.Item bsStyle='warning' onClick={() => this.unarchiveApp(app)}>Unarchive App</Dropdown.Item> : <Dropdown.Item bsStyle='warning' onClick={() => this.archiveApp(app)}>Archive App</Dropdown.Item>}
    //     <Dropdown.Item bsStyle='primary' onClick={() => this.updateStripeExpress(app)}>Reset Stripe Express</Dropdown.Item>
    //     <Dropdown.Item bsStyle='primary' onClick={() => this.updateStripeMonthly(app)}>Remove Subscription Payment</Dropdown.Item>
    //     <Dropdown.Item bsStyle='primary' onClick={() => this.openEditShopifyModal(app)}>Edit Shopify Store Name</Dropdown.Item>
    //     <Dropdown.Item bsStyle='primary' onClick={() => this.copyBuildScript(app)}>Copy Build Script</Dropdown.Item>
    //     <Dropdown.Item bsStyle='primary' onClick={() => this.getPresentationLink(app)}>Get Presentation Link</Dropdown.Item>
    //     <Dropdown.Item bsStyle='primary' onClick={() => this.openDummyUsersModal(app)}>Add Dummy Users</Dropdown.Item>
    //     <Dropdown.Item bsStyle='primary' onClick={() => this.removeUsers(app)}>Delete All Users</Dropdown.Item> */}
    //     <Dropdown.Item bsStyle='primary' onClick={() => this.addToWorking(app)}>Add This App to 'Working On' Apps</Dropdown.Item>
    //     { this.props.user.superAdminPreviewApp === app._id ? <Dropdown.Item bsStyle='primary' onClick={() => this.setAppForPreview(app, false)}>Stop Previewing This App</Dropdown.Item> : <Dropdown.Item bsStyle='primary' onClick={() => this.setAppForPreview(app, true)}>Preview This App in Assistant</Dropdown.Item> }
    //     <Dropdown.Item bsStyle='primary' onClick={() => this.getBillingInfo(app)}>View Billing Info</Dropdown.Item>
    //     <Dropdown.Item bsStyle='primary' onClick={() => this.openEditStoreLinkModal(app)}>App Store Links</Dropdown.Item>
    //     <Dropdown.Item bsStyle='primary' onClick={() => this.consoleLogApp(app)}>
    //     <Dropdown.Item bsStyle='primary' onClick={() => this.setAsPartner(app)}>Set As Partner</Dropdown.Item>
    //     <Dropdown.Item bsStyle='primary' onClick={() => this.openEditPackageIdModal(app)}>Edit Package Id</Dropdown.Item>
    //     <Dropdown.Item bsStyle='primary' onClick={() => this.copyBuildScript(app)}>Copy Build Script</Dropdown.Item>
    //     <Dropdown.Item bsStyle='warning' onClick={() => this.makeAdmin(app)}>Make Admin</Dropdown.Item>
    //     <Dropdown.Item bsStyle='warning' onClick={() => this.deleteApp(app)}>Delete/Suspend App</Dropdown.Item>
    //   </Popover>
    // );
    return (
      <Button onClick={() => this.openAdminAppModal(app)}>
        {/* <FontAwesome
            border={false}
            name="genderless"
            style={{ marginLeft: 3 }}
          />  */}
        <FontAwesomeIcon style={{ marginLeft: 3 }} icon={faGenderless} />
        {/* <FontAwesome
            border={false}
            name="genderless"
            style={{ marginLeft: 3 }}
          /> */}
        <FontAwesomeIcon style={{ marginLeft: 3 }} icon={faGenderless} />
        {/* <FontAwesome
            border={false}
            name="genderless"
            style={{ marginLeft: 3 }}
          /> */}
        <FontAwesomeIcon style={{ marginLeft: 3 }} icon={faGenderless} />
      </Button>
    );
  }

  openAdminAppModal(app: any) {
    // alert('sup');
    this.setState({ appForModal: app, showAppOptionsModal: true });
  }

  closeAdminAppModal() {
    this.setState({ appForModal: {}, showAppOptionsModal: false });
  }

  getMoreShopifyInfo(app: any) {
    // alert(JSON.stringify(app.ownerEmail));
    this.setState({
      showFurtherDetailsModal: false,
      showShopifyInfoModal: true,
      loadingShopifyInfo: true,
      shopifyAppToFetch: app,
    });
    if (
      app.shopifyChargeId &&
      app.shopifyChargeType &&
      app.chosenOptions.shopifyAccessToken
    ) {
      this.props.actions.app.checkShopifyChargeId(
        app.shopifyChargeId,
        app.shopifyChargeType,
        app.chosenOptions.shopifyAccessToken,
        app.chosenOptions.shopifyStoreURL.replace('.myshopify.com', ''),
        (results: any) => {
          if (results && results.status) {
            const modResults = results;
            modResults.shopifyAccessToken =
              app.chosenOptions.shopifyAccessToken;
            modResults.shopifyStoreName =
              app.chosenOptions.shopifyStoreURL.replace('.myshopify.com', '');
            modResults.shopifyChargeType = app.shopifyChargeType;
            if (app.shopifyChargeType === 'yearly') {
              const aYearFrom = new Date(results.created_at);
              aYearFrom.setFullYear(aYearFrom.getFullYear() + 1);
              modResults.activated_on = new Date(
                results.created_at,
              ).toDateString();
              modResults.billing_on = aYearFrom.toDateString();
            }
            this.setState({
              loadingShopifyInfo: false,
              shopifyInfo: modResults,
            });
          } else {
            if (results.fullError) {
              this.setState({
                loadingShopifyInfo: false,
                shopifyInfoError: 'Error from Shopify: ' + results.fullError,
                shopifyClearTokens: results.clearAuthTokens,
              });
            }
          }
        },
      );
    } else {
      let errorMessage =
        'This app does not have the required data to fetch info from Shopify. \nMissing: \n';
      if (!app.shopifyChargeId) {
        errorMessage += '- shopifyChargeId \n';
      }
      if (!app.shopifyChargeType) {
        errorMessage += '- shopifyChargeType \n';
      }
      if (!app.chosenOptions.shopifyAccessToken) {
        errorMessage += '- chosenOptions.shopifyAccessToken \n';
      }

      this.setState({
        loadingShopifyInfo: false,
        shopifyInfoError: errorMessage,
      });
    }
  }

  closeShopifyInfoModal() {
    this.setState({
      loadingShopifyInfo: false,
      shopifyInfoError: '',
      showShopifyInfoModal: false,
      shopifyInfo: {},
      shopifyAppToFetch: {},
      shopifyClearTokens: false,
    });
  }

  cancelShopifySub() {
    const yesno = confirm('Are you sure you want to cancel this subscription?'); // eslint-disable-line
    if (yesno) {
      if (
        this.state.shopifyInfo.id &&
        this.state.shopifyInfo.shopifyChargeType &&
        this.state.shopifyInfo.shopifyAccessToken &&
        this.state.shopifyInfo.shopifyStoreName
      ) {
        this.props.actions.app.cancelShopifyCharge(
          this.state.shopifyInfo.id,
          this.state.shopifyInfo.shopifyChargeType,
          this.state.shopifyInfo.shopifyAccessToken,
          this.state.shopifyInfo.shopifyStoreName,
          (results: any) => {
            if (results.error) {
              alert('Unable to cancel subscription.'); // eslint-disable-line
            } else {
              alert('Subscription cancelled.'); // eslint-disable-line
              this.getMoreShopifyInfo(this.state.shopifyAppToFetch);
            }
          },
        );
      } else {
        alert('Unable to cancel subscription.'); // eslint-disable-line
      }
    }
  }

  clearShopifyTokens() {
    const updates = {
      chosenOptions: JSON.parse(
        JSON.stringify(this.state.shopifyAppToFetch.chosenOptions),
      ),
      shopifyChargeId: '',
      shopifyChargeType: '',
    };
    updates.chosenOptions.shopifyAccessToken = '';
    updates.chosenOptions.shopifyStoreName = '';
    this.props.actions.app.updateApp(
      this.state.shopifyAppToFetch._id,
      updates,
      () => {
        this.closeShopifyInfoModal();
        this.fetchData({
          page: this.state.page,
          pageSize: this.state.pageSize,
        });
      },
    );
  }

  markAsCancelled() {
    const updates = {
      subscriptionPlan: 'unsubscribed',
    };
    this.props.actions.app.updateApp(
      this.state.shopifyAppToFetch._id,
      updates,
      () => {
        this.closeShopifyInfoModal();
        this.fetchData({
          page: this.state.page,
          pageSize: this.state.pageSize,
        });
      },
    );
  }

  changeMode(string: any) {
    if (string === 'customerMode') {
      this.setState({ customerMode: !this.state.customerMode }, () => {
        this.fetchData({
          page: this.state.page,
          pageSize: this.state.pageSize,
        });
      });
    } else if (string === 'archiveMode') {
      this.setState({ archiveMode: !this.state.archiveMode }, () => {
        this.fetchData({
          page: this.state.page,
          pageSize: this.state.pageSize,
        });
      });
    }
  }

  checkApp(app: any) {
    const newCheckedArray = this.state.checkedArray;
    const existIndex = newCheckedArray.indexOf(app._id);
    if (existIndex > -1) {
      newCheckedArray.splice(existIndex, 1);
    } else {
      newCheckedArray.push(app._id);
    }
    this.setState({ checkedArray: newCheckedArray });
  }

  userInstalledCheck(app: any) {
    const results = {
      numberOfUsers: app.activeUsers,
    };

    let newTier = '';
    if (
      results.numberOfUsers &&
      results.numberOfUsers >= 5000 &&
      app.subscriptionPlan !== 'grow'
    ) {
      newTier = 'grow'; // 249
    }
    if (results.numberOfUsers && results.numberOfUsers >= 10000) {
      newTier = 'growPlus'; // 400
    }
    if (results.numberOfUsers && results.numberOfUsers >= 15000) {
      newTier = 'growPlus550'; // 550
    }
    if (results.numberOfUsers && results.numberOfUsers >= 20000) {
      newTier = 'growPlus700'; // 700
    }
    if (results.numberOfUsers && results.numberOfUsers >= 25000) {
      newTier = 'growPlus850';
    }
    if (results.numberOfUsers && results.numberOfUsers >= 30000) {
      newTier = 'growPlus1000';
    }
    if (results.numberOfUsers && results.numberOfUsers >= 35000) {
      newTier = 'growPlus1150';
    }
    if (results.numberOfUsers && results.numberOfUsers >= 40000) {
      newTier = 'growPlus1300';
    }
    if (results.numberOfUsers && results.numberOfUsers >= 45000) {
      newTier = 'growPlus1450';
    }
    if (results.numberOfUsers && results.numberOfUsers >= 50000) {
      newTier = 'growPlus1600';
    }
    if (results.numberOfUsers && results.numberOfUsers >= 55000) {
      newTier = 'growPlus1750';
    }
    if (results.numberOfUsers && results.numberOfUsers >= 60000) {
      newTier = 'growPlus1900';
    }
    if (results.numberOfUsers && results.numberOfUsers >= 65000) {
      newTier = 'growPlus2050';
    }
    if (results.numberOfUsers && results.numberOfUsers >= 70000) {
      newTier = 'growPlus2200';
    }
    if (results.numberOfUsers && results.numberOfUsers >= 75000) {
      newTier = 'growPlus2350';
    }
    if (results.numberOfUsers && results.numberOfUsers >= 80000) {
      newTier = 'growPlus2500';
    }
    if (results.numberOfUsers && results.numberOfUsers >= 85000) {
      newTier = 'growPlus2650';
    }
    if (results.numberOfUsers && results.numberOfUsers >= 90000) {
      newTier = 'growPlus2800';
    }
    if (results.numberOfUsers && results.numberOfUsers >= 95000) {
      newTier = 'growPlus2950';
    }
    // alert(newTier);
    if (newTier) {
      this.props.actions.app.updateApp(
        app._id,
        { subscriptionPlan: newTier },
        () => {},
      );
    }

    if (newTier && app.shopifyChargeId) {
      // dealing with shopify
      const host2 = hosts.ACTIVE_HOST + '/payment/addUsageToShopifyCharge';
      const data2 = {
        chargeId: app.shopifyChargeId,
        plan: newTier,
        storeName: app.chosenOptions.shopifyStoreName,
        apiAuth: app.chosenOptions.shopifyAccessToken,
      };
      const options2 = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          // Authorization: 'Bearer ' + localStorage.getItem('jwtToken')
        },
        method: 'post',
        body: JSON.stringify(data2),
      };

      fetch(host2, options2)
        .then(response => {
          // eslint-disable-line
          return response.json();
        })
        .then(results2 => {})
        .catch(error => {
          // alert('Error creating and assigning app');
          throw error;
        });
    }
  }

  archiveBatch() {
    const host = hosts.ACTIVE_HOST + '/app/batchArchive';

    const data = {
      appIds: this.state.checkedArray,
    };

    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('jwtToken'), // eslint-disable-line
      },
      method: 'post',
      body: JSON.stringify(data),
    };

    fetch(host, options)
      .then(response => {
        // eslint-disable-line
        return response.json();
      })
      .then(results => {
        if (results.message) {
          this.fetchData({
            page: this.state.page,
            pageSize: this.state.pageSize,
          });
        } else {
          alert(results.error); // eslint-disable-line
        }
      })
      .catch(error => {
        alert('There was an error with your request.'); // eslint-disable-line
        throw error;
      });
  }

  openFurtherDetailsModal(app: any) {
    const appCopy = JSON.parse(JSON.stringify(app));
    if (app.lastBilled) {
      const dateSub = new Date(app.lastBilled);
      // const monthOut = new Date(dateSub.setMonth(dateSub.getMonth() + 1));
      const nextBillDate =
        dateSub.getUTCFullYear() +
        '/' +
        (dateSub.getUTCMonth() + 1) +
        '/' +
        dateSub.getUTCDate();
      appCopy.isShopify = false;
      appCopy.nextBillDate = nextBillDate;
      // return ({isShopify: false, nextBillDate, fullApp: o});
    } else if (app.shopifyChargeId) {
      appCopy.isShopify = true;
      // return ({isShopify: true, fullApp: o});
    }

    appCopy.storeUrl = '';
    if (app.chosenOptions && app.chosenOptions.shopifyStoreURL) {
      appCopy.storeUrl = 'https://' + app.chosenOptions.shopifyStoreURL;
    } else if (app.chosenOptions && app.chosenOptions.bcStoreHash) {
      appCopy.storeUrl =
        'https://store-' + app.chosenOptions.bcStoreHash + '.mybigcommerce.com';
    } else if (app.chosenOptions && app.chosenOptions.threeDCartStoreURL) {
      appCopy.storeUrl = app.chosenOptions.threeDCartStoreURL;
    }
    this.setState({ showFurtherDetailsModal: true, appBeingExamined: appCopy });
    this.loadAppEvents(app);
  }

  loadAppEvents(app: any) {
    this.setState({ loadingEvents: true });
    this.props.actions.event.fetchAppEvents(app._id, (events: any) => {
      this.setState({ loadingEvents: false, appEvents: events });
    });
  }

  packageAssets(app: any) {
    function getIcon() {
      return fetch(app.chosenOptions.iconUrl).then(response => response.blob());
    }

    function getGooglePlayImage() {
      return fetch(app.chosenOptions.bannerUrl).then(response =>
        response.blob(),
      );
    }

    function getStudentsAndScores() {
      return Promise.all([getIcon(), getGooglePlayImage()]);
    }

    let media0 = '';
    let media1 = '';
    let media2 = '';
    let media3 = '';
    let media4 = '';

    const text =
      '#!/usr/bin/env bash' +
      '\n\n' +
      'SCRIPTPATH=$(dirname $0)' +
      '\n\n' +
      'sh theScript.sh ' +
      app.ownerId +
      " '" +
      app.chosenOptions.title +
      "' " +
      app.chosenOptions.shopify +
      ' ' +
      app.chosenOptions.bigcommerce +
      " '" +
      app.chosenOptions.iconUrl +
      "' '" +
      app.chosenOptions.storeUrl +
      "' " +
      "false '" +
      'com.sandbox.' +
      app.packageId +
      "' '" +
      app.googleSignInId +
      "' '" +
      'sSXF0deBROiU1Nt4C5GVGw' +
      "' '" +
      '__NtzsBSRsmQrHJhl5kKCg' +
      "' '" +
      media0 +
      "' '" +
      media1 +
      "' '" +
      media2 +
      "' '" +
      media3 +
      "' '" +
      media4 +
      "' '" +
      app.chosenOptions.splashBackground +
      "' " + // launch screen image
      "'#ffffff' " + // launch screen background color
      app._id +
      " '274331966514861' '" + // facebook app id for login
      app.chosenOptions.title +
      "'" +
      '\n\n' +
      'mkdir $SCRIPTPATH/buildMaterials' +
      '\n\n' +
      'curl -o $SCRIPTPATH/buildMaterials/icon.png ' +
      app.chosenOptions.iconUrl +
      '\n\n' +
      'curl -o $SCRIPTPATH/buildMaterials/googlePlayBanner.png ' +
      app.chosenOptions.bannerUrl +
      '\n\n';

    const readme =
      'WHAT TO DO WITH THIS BUNDLE: ' +
      '\n\n' +
      '- copy the buildScript.sh file into the root of the SandBox-Previewer-React-Native directory, overwriting any existing file with the same name' +
      '\n' +
      "- run the file using 'sh buildScript.sh', it may ask for a password, just input the password you use to log in to your computer" +
      '\n' +
      "- this will create a directory called 'buildMaterials' in the root of SandBox-Previewer-React-Native (if it did not already exist), this will contain the assets you need to upload to Google Play" +
      '\n' +
      "- the project should now be configured to build the app you downloaded this bundle for, you can proceed normally using 'sh theScript.sh -build' and/or xcode";

    let zip = new JSZip();
    zip.file('buildScript.sh', text);
    zip.file('shortDescription.txt', app.chosenOptions.shortDesc);
    zip.file('longDescription.t', app.chosenOptions.longDesc);
    zip.file('README.txt', readme);
    // var img = zip.folder("images");
    // img.file("smile.gif", imgData, {base64: true});
    zip.generateAsync({ type: 'blob' }).then(function (content) {
      // see FileSaver.js
      saveAs(content, 'buildKit.zip');
    });

    // getStudentsAndScores()
    // .then(([icon, googlePlayImage]) => {
    //   // both have loaded!
    //
    //
    //
    //
    // })
  }

  handleSorting(id: any) {
    const currentSort = JSON.parse(JSON.stringify(this.state.sorted));
    let newSort: any = [];
    if (currentSort.length === 1) {
      if (currentSort[0].id === id) {
        if (currentSort[0].desc) {
          newSort = [
            {
              id: id,
              desc: false,
            },
          ];
        }
      } else {
        newSort = [
          {
            id: id,
            desc: true,
          },
        ];
      }
    } else {
      newSort = [
        {
          id: id,
          desc: true,
        },
      ];
    }
    this.setState({ sorted: newSort }, () => {
      this.fetchData({ page: this.state.page, pageSize: this.state.pageSize });
    });
  }

  render() {
    const columns = [
      {
        id: 'checkbox',
        show: true,
        Header: () => <span style={styles.header}></span>,
        accessor: (o: any) => {
          return o;
        },
        Cell: (props: any) => (
          <div
            className="checkbox-container checkbox-container-admin"
            style={{
              backgroundColor:
                this.props.user.superAdminPreviewApp === props.value._id
                  ? 'yellow'
                  : 'transparent',
              marginLeft: 10,
            }}
          >
            <Checkbox
              checked={this.state.checkedArray.indexOf(props.value._id) > -1}
              // label="Basic checkbox"
              className="checkBoxAdmin"
              onChange={() => this.checkApp(props.value)}
            />
          </div>
        ),
        width: 50,
      },
      {
        id: 'icon',
        show: this.state.displayColumns.title,
        Header: () => <span style={styles.header}>ICON</span>,
        accessor: (o: any) => {
          return o;
        },
        Cell: (props: any) => (
          <div
            style={{
              backgroundColor:
                this.props.user.superAdminPreviewApp === props.value._id
                  ? 'yellow'
                  : 'white',
            }}
          >
            {props.value &&
            props.value.chosenOptions &&
            props.value.chosenOptions.iconUrl ? (
              <img
                src={props.value.chosenOptions.iconUrl}
                style={{ height: 30, width: 30 }}
              />
            ) : null}
          </div>
        ),
        width: 60,
      },
      {
        id: 'title',
        show: this.state.displayColumns.title,
        Header: () => (
          <span
            style={styles.headerSortable}
            onClick={() => {
              this.handleSorting('title');
            }}
          >
            {/* <FontAwesome
            border={false}
            name='list-alt'
            style={{ marginRight: 5 }}
          /> */}
            <FontAwesomeIcon style={styles.faIcon} icon={faListAlt} />
            APP NAME
            {this.state.sorted[0] &&
            this.state.sorted[0].id === 'title' &&
            this.state.sorted[0].desc
              ? ' ▲'
              : ''}
            {this.state.sorted[0] &&
            this.state.sorted[0].id === 'title' &&
            !this.state.sorted[0].desc
              ? ' ▼'
              : ''}
          </span>
        ),
        accessor: (o: any) => {
          return o;
        },
        Cell: (props: any) => (
          <a
            style={{
              cursor: 'pointer',
              fontSize: 10,
              textDecoration: 'underline',
            }}
            onClick={() => this.preUseApp(props.value)}
          >
            {props.value &&
            props.value.chosenOptions &&
            props.value.chosenOptions.title &&
            props.value.chosenOptions.title !== 'Neaw App'
              ? props.value.chosenOptions.title
              : props.value.chosenOptions.shopifyStoreName
              ? props.value.chosenOptions.shopifyStoreName
              : props.value.chosenOptions.bcStoreHash
              ? props.value.chosenOptions.bcStoreHash
              : props.value.chosenOptions.threeDCartStoreUrl}
          </a>
        ),
        // width: 150
      },
      {
        id: 'fullname',
        show: this.state.displayColumns.fullName,
        Header: () => (
          <span style={styles.header}>
            {/* <FontAwesome
            border={false}
            name='person'
            style={{ marginRight: 5 }}
          /> */}
            <FontAwesomeIcon style={styles.faIcon} icon={faUser} />
            USER'S NAME
          </span>
        ),
        accessor: (o: any) => {
          return o;
        },
        Cell: (
          props: any, // eslint-disable-line
        ) => (
          <a
            style={{
              cursor: 'pointer',
              fontSize: 10,
              textDecoration: 'underline',
            }}
            onClick={() => this.openFurtherDetailsModal(props.value)}
          >
            {props.value &&
            props.value.chosenOptions &&
            props.value.chosenOptions.ownerName &&
            props.value.chosenOptions.ownerName !== ' '
              ? props.value.chosenOptions.ownerName
              : props.value && props.value.ownerEmail
              ? props.value.ownerEmail
              : 'Default Name'}
          </a>
        ),
        // width: 150
      },
      /* {
        id: 'email',
        show: this.state.displayColumns.title,
        Header: () => <span style={styles.header}>
          <FontAwesome
            border={false}
            name='list-alt'
            style={{ marginRight: 5 }}
          />
          EMAIL
        </span>,
        accessor: (o) => {
          return o;
        },
        Cell: props => (
          <a style={{ cursor: 'pointer', fontSize: 10 }} onClick={() => this.useApp(props.value)} >{props.value && props.value.chosenOptions && props.value.ownerEmail}</a>
        ),
        width: 125
      }, */
      {
        id: 'created',
        show: this.state.displayColumns.created,
        Header: () => (
          <span style={styles.header}>
            <FontAwesome
              border={false}
              name="calendar-o"
              style={{ marginRight: 5 }}
            />
            CREATED
          </span>
        ),
        accessor: (o: any) => {
          return this.prettifyDate(o.created);
        },
        Cell: (props: any) => (
          <span style={{ fontSize: 10 }}>{props.value}</span>
        ),
        width: 125,
      },
      {
        id: 'store',
        show: this.state.displayColumns.store,
        Header: () => <span style={styles.header}>STORE TYPE</span>,
        accessor: (o: any) => {
          return o;
        },
        Cell: (props: any) => (
          <div>
            {props.value &&
            props.value.chosenOptions &&
            props.value.chosenOptions.shopifyAccessToken ? (
              <a
                onClick={() => this.onlyStore('onlySF')}
                style={{
                  color: '#95BF47',
                  fontSize: 10,
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
              >
                SHOPIFY
              </a>
            ) : null}
            {props.value &&
            props.value.chosenOptions &&
            props.value.chosenOptions.bcAccessToken ? (
              <a
                onClick={() => this.onlyStore('onlyBC')}
                style={{
                  color: '#5555ff',
                  fontSize: 10,
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
              >
                BIGCOMMERCE
              </a>
            ) : null}
            {(props.value &&
              props.value.chosenOptions &&
              props.value.chosenOptions.threeDCartAccessToken) ||
            props.value.chosenOptions.threeDCart ? (
              <a
                onClick={() => this.onlyStore('only3D')}
                style={{
                  color: '#22AC60',
                  fontSize: 10,
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
              >
                3DCART
              </a>
            ) : null}
          </div>
        ),
        //  width: 125
      },
      /* {
        id: 'activeUsers',
        show: this.state.displayColumns.activeUsers,
        Header: () => <span style={styles.header}>
          ACTIVE USERS
        </span>,
        accessor: (o) => {
          return o;
        },
        Cell: props => <div>
          { props.value && props.value.activeUsers ? <span style={{ color: '#000', fontSize: 12 }} >{props.value.activeUsers}</span> : <span style={{ color: '#000', fontSize: 12 }} >0</span> }
        </div>,
        width: 125
      }, */
      {
        id: 'payment',
        show: this.state.displayColumns.payment,
        Header: () => <span style={styles.header}>PAYMENT</span>,
        accessor: (o: any) => {
          return o;
        },
        Cell: (props: any) => (
          <div>
            {props.value &&
            props.value.chosenOptions &&
            props.value.monthlyStripeAccountId ? (
              <span style={{ color: '#6772e5', fontSize: 10 }}>STRIPE</span>
            ) : null}
            {props.value &&
            props.value.chosenOptions &&
            props.value.shopifyChargeId ? (
              <span style={{ color: '#95BF47', fontSize: 10 }}>SHOPIFY</span>
            ) : null}
            {props.value &&
            props.value.chosenOptions &&
            !props.value.shopifyChargeId &&
            !props.value.monthlyStripeAccountId ? (
              <span style={{ color: '#ff7c00', fontSize: 10 }}>NONE YET</span>
            ) : null}
          </div>
        ),
        // width: 75
      },
      {
        id: 'revenue',
        show: this.state.displayColumns.payment,
        Header: () => <span style={styles.header}>REVENUE</span>,
        accessor: (o: any) => {
          return o;
        },
        Cell: (props: any) => (
          <span style={{ fontSize: 10 }}>
            {props.value.revenue ? props.value.revenue : 'Coming Soon'}
          </span>
        ),
        // width: 75
      },
      {
        id: 'lastBilled',
        show: this.state.displayColumns.billing,
        Header: () => <span style={styles.header}>NEXT BILL DATE</span>,
        accessor: (o: any) => {
          if (o.lastBilled) {
            const dateSub = new Date(o.lastBilled);
            const monthOut = new Date(dateSub.setMonth(dateSub.getMonth() + 1));
            const nextBillDate =
              monthOut.getUTCFullYear() +
              '/' +
              (monthOut.getUTCMonth() + 1) +
              '/' +
              monthOut.getUTCDate();
            return { isShopify: false, nextBillDate, fullApp: o };
          } else if (o.shopifyChargeId) {
            return { isShopify: true, fullApp: o };
          } else if (o.trialEndDate) {
            const dateSub = new Date(o.trialEndDate);
            const monthOut = new Date(dateSub.setMonth(dateSub.getMonth()));
            const nextBillDate =
              monthOut.getUTCFullYear() +
              '/' +
              (monthOut.getUTCMonth() + 1) +
              '/' +
              monthOut.getUTCDate();
            return { isShopify: false, nextBillDate, fullApp: o };
          } else {
            return {};
          }
        },
        Cell: (props: any) => (
          <div>
            {props.value && props.value.nextBillDate ? (
              <span style={{ fontSize: 10 }}>{props.value.nextBillDate}</span>
            ) : null}
            {props.value && props.value.isShopify ? (
              <span style={{ fontSize: 10, cursor: 'pointer' }}>
                <a onClick={() => this.getMoreShopifyInfo(props.value.fullApp)}>
                  Shopify Billing Info
                </a>
              </span>
            ) : null}
            {props.value &&
            !props.value.isShopify &&
            !props.value.nextBillDate ? (
              <span style={{ fontSize: 10, color: 'grey' }}>
                {'Not Subscribed'}
              </span>
            ) : null}
          </div>
        ),
      },
      {
        id: 'trialEndDate',
        show: this.state.displayColumns.trialEndDate,
        Header: () => (
          <span
            style={styles.headerSortable}
            onClick={() => {
              this.handleSorting('trialEndDate');
            }}
          >
            DAYS UNTIL TRIAL ENDS
            {this.state.sorted[0] &&
            this.state.sorted[0].id === 'trialEndDate' &&
            this.state.sorted[0].desc
              ? ' ▲'
              : ''}
            {this.state.sorted[0] &&
            this.state.sorted[0].id === 'trialEndDate' &&
            !this.state.sorted[0].desc
              ? ' ▼'
              : ''}
          </span>
        ),
        accessor: (o: any) => {
          let trialEndDate = 'Ended';
          if (o.trialEndDate) {
            // trialEndDate = new Date(o.trialEndDate);
            // trialEndDate = trialEndDate.toString();
            const a = moment(o.trialEndDate);
            const b = moment();
            trialEndDate = a.diff(b, 'days');
            if (trialEndDate < 1) {
              trialEndDate = 'Trial Ended';
            }
          }
          return trialEndDate;
        },
        Cell: (props: any) => (
          <span style={{ fontSize: 10 }}>{props.value}</span>
        ),
      },
      {
        id: 'trialEndDate2',
        show: this.state.displayColumns.trialEndDate,
        Header: () => (
          <span
            style={styles.headerSortable}
            onClick={() => {
              this.handleSorting('trialEndDate2');
            }}
          >
            TRIAL END DATE
            {this.state.sorted[0] &&
            this.state.sorted[0].id === 'trialEndDate2' &&
            this.state.sorted[0].desc
              ? ' ▲'
              : ''}
            {this.state.sorted[0] &&
            this.state.sorted[0].id === 'trialEndDate2' &&
            !this.state.sorted[0].desc
              ? ' ▼'
              : ''}
          </span>
        ),
        accessor: (o: any) => {
          let trialEndDate = 'No Trial';
          if (o.trialEndDate) {
            trialEndDate = moment(o.trialEndDate).format('MM-DD-YYYY');
            // trialEndDate = trialEndDate.toString();
          }
          return trialEndDate;
        },
        Cell: (props: any) => (
          <span style={{ fontSize: 10 }}>{props.value}</span>
        ),
      },
      {
        id: 'tier',
        show: this.state.displayColumns.tier,
        Header: () => (
          <span
            style={styles.headerSortable}
            onClick={() => {
              this.handleSorting('tier');
            }}
          >
            TIER
            {this.state.sorted[0] &&
            this.state.sorted[0].id === 'tier' &&
            this.state.sorted[0].desc
              ? ' ▲'
              : ''}
            {this.state.sorted[0] &&
            this.state.sorted[0].id === 'tier' &&
            !this.state.sorted[0].desc
              ? ' ▼'
              : ''}
          </span>
        ),
        accessor: (o: any) => {
          const trialPlus1 = new Date(o.trialEndDate);
          trialPlus1.setDate(trialPlus1.getDate() + 1);
          if (
            o.subscriptionPlan &&
            (o.monthlyStripeAccountId || o.shopifyChargeId)
          ) {
            if (trialPlus1 > new Date()) {
              if (
                o.subscriptionPlan === 'instagram' ||
                (o.chosenOptions && o.chosenOptions.socialApp)
              ) {
                return 'Social Trial';
              } else {
                return 'Trial';
              }
            }
            return (
              o.subscriptionPlan.charAt(0).toUpperCase() +
              o.subscriptionPlan.slice(1)
            );
          } else if (!o.monthlyStripeAccountId && !o.shopifyChargeId) {
            if (
              o.subscriptionPlan === 'instagram' ||
              (o.chosenOptions && o.chosenOptions.socialApp)
            ) {
              return 'Social Paywall';
            } else {
              return 'Paywall';
            }
          } else {
            return 'None Yet';
          }
        },
        Cell: (props: any) => (
          <span style={{ fontSize: 10 }}>{props.value}</span>
        ),
        // width: 75
      },
      {
        id: 'publishStatus',
        show: this.state.displayColumns.publishStatus,
        Header: () => <span style={styles.header}>PUBLISH STATUS</span>,
        accessor: (o: any) => {
          return o;
        },
        Cell: (props: any) => (
          <span style={{ fontSize: 10 }}>
            {props.value.submittedForReview
              ? 'Published'
              : props.value.subscriptionPlan === 'instagram'
              ? 'N/A'
              : 'Pending...'}
          </span>
        ),
        // width: 75
      },
      {
        id: 'deploymentStatus',
        show: this.state.displayColumns.deploymentStatus,
        Header: () => <span style={styles.header}>DEPLOYMENT STATUS</span>,
        accessor: (o: any) => {
          return o;
        },
        Cell: (props: any) => (
          <div
            onClick={() => this.openEditDeploymentStatusModal(props.value)}
            style={{ cursor: 'pointer' }}
          >
            <p>Apple: {props.value.appleProgress}</p>
            <p>Android: {props.value.googleProgress}</p>
          </div>
        ),
        width: 175,
      },
      {
        id: 'activeUsers',
        show: this.state.displayColumns.activeUsers,
        Header: () => (
          <span
            style={styles.headerSortable}
            onClick={() => {
              this.handleSorting('activeUsers');
            }}
          >
            USERS
            {this.state.sorted[0] &&
            this.state.sorted[0].id === 'activeUsers' &&
            this.state.sorted[0].desc
              ? ' ▲'
              : ''}
            {this.state.sorted[0] &&
            this.state.sorted[0].id === 'activeUsers' &&
            !this.state.sorted[0].desc
              ? ' ▼'
              : ''}
          </span>
        ),
        accessor: (o: any) => {
          return o;
        },
        Cell: (props: any) => (
          <span style={{ fontSize: 10 }}>{props.value.activeUsers}</span>
        ),
        width: 75,
      },
      {
        id: 'roughSize',
        show: this.state.displayColumns.roughSize,
        Header: () => <span style={styles.header}>ROUGH DATA SIZE</span>,
        accessor: (o: any) => {
          return roughSizeOfObject(o);
        },
        Cell: (props: any) => (
          <span style={{ fontSize: 10 }}>{props.value.toFixed(1) + ' KB'}</span>
        ),
        width: 75,
      },
      /* {
        id: 'previewing',
        show: this.state.displayColumns.payment,
        Header: () => <span style={styles.header}>
          PREVIEWING
        </span>,
        accessor: (o) => {
          return o;
        },
        Cell: props => <div>
          { this.props.user.superAdminPreviewApp === props.value._id ? <span style={{ color: '#000000', fontSize: 10 }} >PREVIEWING</span> : null }
          { this.props.user.superAdminWorkingApps && this.props.user.superAdminWorkingApps.indexOf(props.value._id) > -1 ? <span style={{ color: '#000000', fontSize: 10 }} >WORKING</span> : null }
        </div>,
        width: 80
      },
      {
        id: 'archived',
        show: this.state.displayColumns.archived,
        Header: () => <span style={styles.header}>
          <FontAwesome
            border={false}
            name='exclamation'
            style={{ marginRight: 5 }}
          />
          STATUS
        </span>,
        accessor: (o) => { return o; },
        Cell: props => <div>
          { props.value.admin ? <span style={{ color: 'green', fontSize: 10 }} >ADMIN</span> : null }
          { !props.value.admin && props.value.deleted ? <span style={{ color: 'red', fontSize: 10 }} >ARCHIVED</span> : null }
          { !props.value.admin && !props.value.deleted && props.value.archived ? <span style={{ color: 'orange', fontSize: 10 }} >ARCHIVED</span> : null }
          { props.value.isPartner ? <span style={{ color: 'cyan', fontSize: 10 }} >PARTNER</span> : null }
        </div>,
        width: 80
      }, */
      {
        id: 'tools',
        show: this.state.displayColumns.tools,
        Header: () => (
          <span style={styles.header}>
            {/* <FontAwesome
            border={false}
            name='settings'
            style={{ marginRight: 5 }}
          /> */}
            <FontAwesomeIcon style={styles.faIcon} icon={faCog} />
            TOOLS
          </span>
        ),
        accessor: (o: any) => {
          return o;
        },
        Cell: (props: any) => this.constructOptionsButton(props.value),
        // width: 100
      },
    ];

    return (
      <div style={styles.section}>
        <Row
          style={{
            padding: '0',
            marginBottom: 10,
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Col xs={2}>
            {this.state.checkedArray.length > 0 ? (
              <Button
                primary
                id="orange-button"
                onClick={() => this.archiveBatch()}
                style={{ padding: '5px 0px' }}
              >
                Archive Selected
              </Button>
            ) : null}
          </Col>
          <Col xs={4}>
            <TextField
              placeholder="Enter a search term..."
              value={this.state.searchString}
              onChange={this.updateSearchString}
              id="searchInputAdmin"
            />
          </Col>
          <Col xs={1} style={{ maxWidth: 'none' }}>
            <Button
              primary
              id="orange-button"
              onClick={() =>
                this.fetchData({
                  page: this.state.page,
                  pageSize: this.state.pageSize,
                })
              }
            >
              Search
            </Button>
          </Col>
          <Col xs={2}>
            <Checkbox
              label="Has Active Payment Data"
              checked={this.state.customerMode}
              id="customerMode"
              name="customerMode"
              onChange={() => this.changeMode('customerMode')}
            />
          </Col>
          <Col xs={2}>
            <Checkbox
              label="Show Archived Apps"
              checked={this.state.archiveMode}
              id="archiveMode"
              name="archiveMode"
              onChange={() => this.changeMode('archiveMode')}
            />
          </Col>
          {/* <Col xs={2}> */}
          {/* <Button primary id='orange-button' onClick={() => this.copyBuildScript(this.props.app)}>Search</Button> */}
          {/* </Col> */}
        </Row>

        {/* <ReactTable
          style={{height: window.innerHeight - 230, marginBottom: 50}}
          manual // Forces table not to paginate or sort automatically, so we can handle it server-side
          data={this.state.data}
          pages={this.state.totalPages} // Display the total number of pages
          loading={this.state.loading} // Display the loading overlay when we need it
          // onFetchData={this.fetchData} // Request new data when things change
          defaultPageSize={10}
          columns={columns}
          sorted={this.state.sorted}
          page={this.state.page}
          pageSize={this.state.pageSize}
          filtered={this.state.filtered}
          onSortedChange={(sorted) => {
            // alert(JSON.stringify(sorted));
            if (sorted.length && sorted[sorted.length - 1] && sorted[sorted.length - 1].id && sorted[sorted.length - 1].id !== 'lastBilled') {
              this.setState({sorted}, () => {
                this.fetchData({page: this.state.page, pageSize: this.state.pageSize});
              });
            }
          }}
          onPageChange={(page) => {
            this.setState({ page }, () => {
              this.fetchData({ page: this.state.page, pageSize: this.state.pageSize });
            });
          }}
          onPageSizeChange={(pageSize, page) => {
            this.setState({ page, pageSize }, () => {
              this.fetchData({ page: this.state.page, pageSize: this.state.pageSize });
            });
          }}
          onFilteredChange={filtered => this.setState({ filtered })}
          defaultSorted={[{
            id: 'created',
            desc: true
          }]}
        /> */}

        <Table
          columns={columns}
          data={this.state.data}
          pageManual={this.state.page}
          pageSizeManual={this.state.pageSize}
          pageCount={this.state.totalPages}
          onPageChange={(page: any) => {
            this.setState({ page }, () => {
              this.fetchData({
                page: this.state.page,
                pageSize: this.state.pageSize,
              });
            });
          }}
          onPageSizeChange={(pageSize: any, page: any) => {
            this.setState({ page, pageSize }, () => {
              this.fetchData({
                page: this.state.page,
                pageSize: this.state.pageSize,
              });
            });
          }}
          loading={this.state.loading}
          // onSortedChange={(sorted) => {
          //   // alert(JSON.stringify(sorted));
          //   if (sorted.length && sorted[sorted.length - 1] && sorted[sorted.length - 1].id && sorted[sorted.length - 1].id !== 'lastBilled') {
          //     this.setState({sorted}, () => {
          //       this.fetchData({page: this.state.page, pageSize: this.state.pageSize});
          //     });
          //   }
          // }}
        />

        <Modal
          show={this.state.showCustomerConfirmationSwal}
          onHide={() => this.setState({ showCustomerConfirmationSwal: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              {'This action will immediately charge the client $' +
                this.state.customerConfirmationSwalPrice.toFixed(2) +
                ", which is a prorated amount for the '" +
                this.state.customerConfirmationSwalPlan +
                "' plan which will bill in its entirety " +
                this.state.customerConfirmationSwalNumberOfDays +
                ' days from now. Are you sure you wish to proceed?'}
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.preUpdateCustomerSupportTier}>Yes</Button>
            <Button
              onClick={() =>
                this.setState({ showCustomerConfirmationSwal: false })
              }
            >
              No
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.showFurtherDetailsModal}
          onHide={() =>
            this.setState({
              showFurtherDetailsModal: false,
              appBeingExamined: {},
            })
          }
          centered
          style={{ zIndex: 10000 }}
          size={'xl'}
        >
          <div>
            <Modal.Header
              style={{ color: 'black', borderBottom: 'none' }}
              closeButton
            >
              <Modal.Title>Further Details</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ color: 'black' }}>
              <div>
                <div
                  style={{
                    width: '45%',
                    height: 500,
                    float: 'left',
                    borderRightStyle: 'solid',
                    borderRightWidth: 1,
                    borderRightColor: '#000000',
                    marginRight: '5%',
                  }}
                >
                  <h2
                    style={{
                      textAlign: 'center',
                      fontSize: 18,
                      margin: 10,
                      fontWeight: 600,
                    }}
                  >
                    App Information
                  </h2>
                  <table style={{ width: '100%' }}>
                    <tr>
                      <th>Name</th>
                      <td>
                        {this.state.appBeingExamined.chosenOptions &&
                          this.state.appBeingExamined.chosenOptions.ownerName}
                      </td>
                    </tr>
                    <tr>
                      <th>Email</th>
                      <td>
                        {this.state.appBeingExamined.chosenOptions &&
                          this.state.appBeingExamined.ownerEmail}
                      </td>
                    </tr>
                    <tr>
                      <th>Phone</th>
                      <td>
                        {this.state.appBeingExamined.chosenOptions &&
                          this.state.appBeingExamined.chosenOptions.phone}
                      </td>
                    </tr>
                    <tr>
                      <th>Created Date</th>
                      <td>
                        {this.prettifyDate(this.state.appBeingExamined.created)}
                      </td>
                    </tr>
                    <tr>
                      <th>Store Name</th>
                      <td>
                        {this.state.appBeingExamined.chosenOptions &&
                        this.state.appBeingExamined.chosenOptions.title &&
                        this.state.appBeingExamined.chosenOptions.title !==
                          'New App'
                          ? this.state.appBeingExamined.chosenOptions &&
                            this.state.appBeingExamined.chosenOptions.title
                          : this.state.appBeingExamined.chosenOptions &&
                            this.state.appBeingExamined.chosenOptions
                              .shopifyStoreName
                          ? this.state.appBeingExamined.chosenOptions &&
                            this.state.appBeingExamined.chosenOptions
                              .shopifyStoreName
                          : this.state.appBeingExamined.chosenOptions &&
                            this.state.appBeingExamined.chosenOptions
                              .bcStoreHash}
                      </td>
                    </tr>
                    <tr>
                      <th>Store URL</th>
                      <td>
                        <a
                          href={this.state.appBeingExamined.storeUrl}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {this.state.appBeingExamined.storeUrl}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <th>Total Downloads</th>
                      <td>TBD</td>
                    </tr>
                    <tr>
                      <th>Active Users</th>
                      <td>
                        {this.state.appBeingExamined.activeUsers
                          ? this.state.appBeingExamined.activeUsers
                          : 0}
                      </td>
                    </tr>
                    <tr>
                      <th>Inactive Users</th>
                      <td>TBD</td>
                    </tr>
                    <tr>
                      <th>Payment Type</th>
                      <td>
                        {this.state.appBeingExamined.chosenOptions &&
                        this.state.appBeingExamined.monthlyStripeAccountId
                          ? 'STRIPE'
                          : null}
                        {this.state.appBeingExamined.chosenOptions &&
                        this.state.appBeingExamined.shopifyChargeId
                          ? 'SHOPIFY'
                          : null}
                      </td>
                    </tr>
                    <tr>
                      <th>Last Payment</th>
                      <td>
                        {this.state.appBeingExamined &&
                        this.state.appBeingExamined.nextBillDate
                          ? this.state.appBeingExamined.nextBillDate
                          : null}
                        {this.state.appBeingExamined &&
                        this.state.appBeingExamined.isShopify ? (
                          <span style={{ fontSize: 12, cursor: 'pointer' }}>
                            <a
                              onClick={() =>
                                this.getMoreShopifyInfo(
                                  this.state.appBeingExamined,
                                )
                              }
                            >
                              Click for Shopify Charge Info
                            </a>
                          </span>
                        ) : null}
                      </td>
                    </tr>
                    <tr>
                      <th>Tier</th>
                      <td>
                        {this.state.appBeingExamined.subsciptionPlan
                          ? this.state.appBeingExamined.subscriptionPlan
                              .charAt(0)
                              .toUpperCase() +
                            this.state.appBeingExamined.subscriptionPlan.slice(
                              1,
                            )
                          : new Date(this.state.appBeingExamined.trialEndDate) >
                            new Date()
                          ? 'Trial'
                          : 'Expired'}
                      </td>
                    </tr>
                  </table>
                </div>
                <div
                  style={{
                    width: '50%',
                    float: 'right',
                    height: 500,
                    overflowY: 'scroll',
                  }}
                >
                  <h2
                    style={{
                      textAlign: 'center',
                      fontSize: 18,
                      margin: 10,
                      fontWeight: 600,
                    }}
                  >
                    Recent Active User Events (In-App)
                  </h2>
                  {!this.state.loadingEvents ? (
                    <table style={{ width: '100%' }}>
                      <tr>
                        <th>USER</th>
                        <th>TYPE</th>
                        <th>TIMESTAMP</th>
                      </tr>
                      {this.state.appEvents.map((event: any, index: any) => {
                        return (
                          <tr key={index}>
                            <td>{event.customerId}</td>
                            <td>{event.description}</td>
                            <td>{event.timeStamp}</td>
                          </tr>
                        );
                      })}
                    </table>
                  ) : (
                    <p>Loading....</p>
                  )}
                </div>
              </div>
            </Modal.Body>
          </div>
        </Modal>

        <Modal
          show={this.state.showBillingModal}
          onHide={() => this.setState({ showBillingModal: false })}
          centered
          style={{ zIndex: 10000 }}
        >
          <div>
            <Modal.Header
              style={{ color: 'black', borderBottom: 'none' }}
              closeButton
            ></Modal.Header>
            <Modal.Body style={{ color: 'black', paddingBottom: 100 }}>
              <div>
                <Row style={{ marginBottom: 20, marginLeft: 5 }}>
                  <h3
                    className="account-page-header"
                    style={{ fontWeight: 700 }}
                  >
                    Current Plan{' '}
                  </h3>
                  <h3 className="account-page-header">
                    <span>{this.state.billingOverviewInfo.currentPlan}</span>
                  </h3>
                  {this.state.billingOverviewInfo.test ? (
                    <h3 className="account-page-header">
                      <span style={{ color: 'orange' }}>Test</span>
                    </h3>
                  ) : null}
                </Row>
                <Row style={{ marginBottom: 20, marginLeft: 5 }}>
                  <h3
                    className="account-page-header"
                    style={{ fontWeight: 700 }}
                  >
                    Member Since{' '}
                  </h3>
                  <h3 className="account-page-header">
                    <span>{this.state.billingOverviewInfo.dateSince}</span>
                  </h3>
                </Row>
                <Row style={{ marginBottom: 20, marginLeft: 5 }}>
                  <h3
                    className="account-page-header"
                    style={{ fontWeight: 700 }}
                  >
                    Next Bill Date{' '}
                  </h3>
                  <h3 className="account-page-header">
                    <span>{this.state.billingOverviewInfo.nextBillDate}</span>
                  </h3>
                </Row>
              </div>
            </Modal.Body>
          </div>
        </Modal>

        <Modal
          show={this.state.showEditPackageIdModal}
          onHide={() => this.setState({ showEditPackageIdModal: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit Package Id</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>Package Id</h4>
            <Form horizontal>
              <FormGroup controlId="term">
                <Col sm={12}>
                  <FormControl
                    className="customInputText"
                    type="text"
                    name="packageId"
                    placeholder="packageId"
                    value={this.state.packageIdString}
                    onChange={this.updatePackageIdState}
                  />
                </Col>
              </FormGroup>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() => this.setState({ showEditPackageIdModal: false })}
            >
              Close
            </Button>
            <Button onClick={this.updatePackageId}>Update</Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.showEditSubscriptionModal}
          onHide={() => this.setState({ showEditSubscriptionModal: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit Subscription PLan</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>
              Enter thew new subscription plan in all lower case, ie; 'launch'
            </h4>
            <Form horizontal>
              <FormGroup controlId="term">
                <Col sm={12}>
                  <FormControl
                    className="customInputText"
                    type="text"
                    name="subscriptionPlan"
                    placeholder="subscription plan"
                    value={this.state.subscriptionPlanString}
                    onChange={this.updateSubscriptionPlanState}
                  />
                </Col>
              </FormGroup>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() =>
                this.setState({ showEditSubscriptionModal: false })
              }
            >
              Close
            </Button>
            <Button onClick={this.updateSubscriptionPlan}>Update</Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.showEditDeploymentStatusModal}
          onHide={() => this.setState({ showEditDeploymentStatusModal: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit Deployment Status</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>Apple App Store</h4>
            <Form horizontal>
              <FormGroup controlId="term">
                <Col sm={12}>
                  <FormControl
                    className="customInputText"
                    type="text"
                    name="ios"
                    placeholder="deployment status"
                    value={this.state.deploymentStatusStringIOS}
                    onChange={this.updateDeploymentStatusState}
                  />
                </Col>
              </FormGroup>
            </Form>
            <h4>Google Play Store</h4>
            <Form horizontal>
              <FormGroup controlId="term">
                <Col sm={12}>
                  <FormControl
                    className="customInputText"
                    type="text"
                    name="android"
                    placeholder="deployment status"
                    value={this.state.deploymentStatusStringANDROID}
                    onChange={this.updateDeploymentStatusState}
                  />
                </Col>
              </FormGroup>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() =>
                this.setState({ showEditDeploymentStatusModal: false })
              }
            >
              Close
            </Button>
            <Button onClick={this.updateDeploymentStatus}>Update</Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.showEditCustomerSupportTierModal}
          onHide={() =>
            this.setState({ showEditCustomerSupportTierModal: false })
          }
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit Support Tier</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>Select Customer Support Tier</h4>
            <div>
              <Checkbox
                label="Basic"
                checked={this.state.customerSupportPlanToBeEdited === 'basic'}
                id="customerTierBasic"
                name="customerTierBasic"
                onChange={() => this.updateCustomerSupportTierState('basic')}
                style={{ marginRight: 10 }}
              />
              <br />
              <Checkbox
                label="Advanced"
                checked={
                  this.state.customerSupportPlanToBeEdited === 'advanced'
                }
                id="customerTierAdvanced"
                name="customerTierAdvanced"
                onChange={() => this.updateCustomerSupportTierState('advanced')}
                style={{ marginRight: 10 }}
              />
              <br />
              <Checkbox
                label="Enterprise"
                checked={
                  this.state.customerSupportPlanToBeEdited === 'enterprise'
                }
                id="customerTierEnterprise"
                name="customerTierEnterprise"
                onChange={() =>
                  this.updateCustomerSupportTierState('enterprise')
                }
                style={{ marginRight: 10 }}
              />
              <br />
            </div>
            <h4>Enterprise Support Tier Price</h4>
            <Form horizontal>
              <FormGroup controlId="term">
                <Col sm={12}>
                  <FormControl
                    disabled={
                      this.state.customerSupportPlanToBeEdited !== 'enterprise'
                    }
                    className="customInputText"
                    type="text"
                    name="custom price"
                    placeholder="custom price"
                    value={this.state.customerSupportCustomPriceToBeEdited}
                    onChange={this.updateCustomerSupportCustomPriceState}
                  />
                </Col>
              </FormGroup>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.prePreUpdateCustomerSupportTier}>
              Update
            </Button>
            <Button
              onClick={() =>
                this.setState({ showEditCustomerSupportTierModal: false })
              }
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.showAppStoreModal}
          onHide={() => this.setState({ showAppStoreModal: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Modify App Store Links</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>Google Play Store</h4>
            <Form horizontal>
              <FormGroup controlId="term">
                <Col sm={12}>
                  <FormControl
                    className="customInputText"
                    type="text"
                    name="playStore"
                    placeholder="Play Store URL"
                    value={this.state.playStoreString}
                    onChange={this.updateStoreLinkState}
                  />
                </Col>
                <Col sm={12}>
                  <FormControl
                    className="customInputText"
                    type="text"
                    name="androidVersionString"
                    placeholder="Version Number"
                    value={this.state.androidVersionString}
                    onChange={this.updateStoreLinkState}
                  />
                </Col>
              </FormGroup>
            </Form>
            <h4>Apple App Store</h4>
            <Form horizontal>
              <FormGroup controlId="term">
                <Col sm={12}>
                  <FormControl
                    className="customInputText"
                    type="text"
                    name="itunes"
                    placeholder="App Store URL"
                    value={this.state.itunesString}
                    onChange={this.updateStoreLinkState}
                  />
                </Col>
                <Col sm={12}>
                  <FormControl
                    className="customInputText"
                    type="text"
                    name="appleVersionString"
                    placeholder="Version Number"
                    value={this.state.appleVersionString}
                    onChange={this.updateStoreLinkState}
                  />
                </Col>
              </FormGroup>
            </Form>
            <p>
              {'<script type="text/javascript">'}
              {
                'var i=(/iphone|ipad|ipod/i.test(navigator.userAgent.toLowerCase()));'
              }
              {'var a=(/android/i.test(navigator.userAgent.toLowerCase()));'}
              {"var t='" + this.state.itunesString + "';"}
              {"var g='" + this.state.playStoreString + "';"}
              {'if(i||a){'}
              {
                "if(confirm('This store has a mobile app!  Would you like to download the mobile app?')){"
              }
              {'if(i&&t){'}
              {'window.open(t);'}
              {'}else if(a && g){'}
              {'window.open(g);'}
              {'}'}
              {'}'}
              {'}'}
              {'</script>'}
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.updateStoreLinks}>Update</Button>
            <Button onClick={() => this.setState({ showAppStoreModal: false })}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.showEditTrialModal}
          onHide={() => this.setState({ showEditTrialModal: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit Trial End Date</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>Date</h4>
            <Form horizontal>
              <FormGroup controlId="term">
                <Col sm={12}>
                  <FormControl
                    className="customInputText"
                    type="text"
                    name="term"
                    placeholder="Date (Important: mm/dd/yyyy format)"
                    onChange={this.updateTrialEndState}
                  />
                </Col>
              </FormGroup>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.updateTrial}>Update</Button>
            <Button
              onClick={() => this.setState({ showEditTrialModal: false })}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.showEditUserCountModal}
          onHide={() => this.setState({ showEditUserCountModal: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit User Count</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>Users</h4>
            <Form horizontal>
              <FormGroup controlId="term">
                <Col sm={12}>
                  <FormControl
                    className="customInputText"
                    type="text"
                    name="term"
                    placeholder="Number of users"
                    onChange={this.updateUserCountState}
                  />
                </Col>
              </FormGroup>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.updateUserCount}>Update</Button>
            <Button
              onClick={() => this.setState({ showEditUserCountModal: false })}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.showEditShopifyTrialModal}
          onHide={() => this.setState({ showEditShopifyTrialModal: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Enter Number of Extra Days (10, 30, 60, or 365)
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>Date</h4>
            <Form horizontal>
              <FormGroup controlId="term">
                <Col sm={12}>
                  <FormControl
                    className="customInputText"
                    type="text"
                    name="term"
                    placeholder="Number of days"
                    onChange={this.updateShopifyTrialEndState}
                  />
                </Col>
              </FormGroup>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.updateShopifyTrial}>Update</Button>
            <Button
              onClick={() =>
                this.setState({ showEditShopifyTrialModal: false })
              }
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.showAppOptionsModal}
          onHide={this.closeAdminAppModal}
          centered={true}
          size="md"
        >
          <Modal.Header closeButton>
            <Modal.Title
              style={{
                fontFamily: 'Inter',
                letterSpacing: '-0.022em',
                fontWeight: 'bold',
              }}
            >
              APP OPTIONS
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.props.user.specialPermissionTier &&
            (this.props.user.specialPermissionTier === 'customerSuccess' ||
              this.props.user.specialPermissionTier === 'admin') ? (
              <div style={{ marginBottom: 10 }}>
                <p style={{ fontSize: 14, fontWeight: 'bold' }}>
                  Customer Success
                </p>
                <a
                  style={styles.modalLink}
                  onClick={() =>
                    this.openEditCustomerSupportTierModal(
                      this.state.appForModal,
                    )
                  }
                >
                  Edit Customer Support Tier
                </a>
                {this.state.appForModal.shopifyChargeId ? (
                  <a
                    bsStyle="primary"
                    onClick={() =>
                      this.getMoreShopifyInfo(this.state.appForModal)
                    }
                    style={{ fontFamily: 'Inter', fontStyle: 'normal' }}
                  >
                    View Shopify Billing Info
                  </a>
                ) : null}
                <a
                  style={styles.modalLink}
                  onClick={() =>
                    this.openEditStoreLinkModal(this.state.appForModal)
                  }
                >
                  Add/Edit App Store Links and Version Numbers
                </a>
                {false ? (
                  <a
                    style={styles.modalLink}
                    onClick={() =>
                      this.openEditSubscriptionModal(this.state.appForModal)
                    }
                  >
                    Edit Subscription Plan
                  </a>
                ) : null}
                {!this.state.appForModal.partnerApp ? (
                  <a
                    style={styles.modalLink}
                    onClick={() => this.setAsPartner(this.state.appForModal)}
                  >
                    Make Partner
                  </a>
                ) : null}
                <a
                  style={styles.modalLink}
                  onClick={() =>
                    this.partnerPaywallSkip(this.state.appForModal)
                  }
                >
                  Partner Paywall Skip
                </a>
                {this.state.appForModal.chosenOptions &&
                this.state.appForModal.chosenOptions.shopifyAccessToken ? (
                  <a
                    style={styles.modalLink}
                    onClick={() =>
                      this.openEditShopifyTrialModal(this.state.appForModal)
                    }
                  >
                    Update Shopify Trial End
                  </a>
                ) : (
                  <a
                    style={styles.modalLink}
                    onClick={() =>
                      this.openEditTrialModal(this.state.appForModal)
                    }
                  >
                    Update Trial End
                  </a>
                )}
              </div>
            ) : null}
            {this.props.user.specialPermissionTier &&
            (this.props.user.specialPermissionTier === 'qa' ||
              this.props.user.specialPermissionTier === 'developer' ||
              this.props.user.specialPermissionTier === 'admin') ? (
              <div style={{ marginBottom: 10 }}>
                <p style={{ fontSize: 14, fontWeight: 'bold' }}>QA</p>
                <a
                  style={styles.modalLink}
                  onClick={() => this.addToWorking(this.state.appForModal)}
                >
                  {this.props.user.superAdminWorkingApps.indexOf(
                    this.state.appForModal._id,
                  ) > -1
                    ? 'Remove This App from "Working On" Apps'
                    : 'Add This App to "Working On" Apps'}
                </a>
              </div>
            ) : null}
            {this.props.user.specialPermissionTier &&
            (this.props.user.specialPermissionTier === 'developer' ||
              this.props.user.specialPermissionTier === 'admin') ? (
              <div style={{ marginBottom: 10 }}>
                <p style={{ fontSize: 14, fontWeight: 'bold' }}>Developer</p>
                <a
                  style={styles.modalLink}
                  onClick={() =>
                    this.openEditDeploymentStatusModal(this.state.appForModal)
                  }
                >
                  Edit Deployment Status
                </a>
                <a
                  style={styles.modalLink}
                  onClick={() => this.consoleLogApp(this.state.appForModal)}
                ></a>
                <a
                  style={styles.modalLink}
                  onClick={() =>
                    this.openEditPackageIdModal(this.state.appForModal)
                  }
                >
                  Edit Package Id
                </a>
                <a
                  style={styles.modalLink}
                  onClick={() => this.copyBuildScript(this.state.appForModal)}
                >
                  Copy Build Script
                </a>
                <a
                  style={styles.modalLink}
                  onClick={() => this.packageAssets(this.state.appForModal)}
                >
                  Download App Build Bundle Kit
                </a>
              </div>
            ) : null}
            {this.props.user.specialPermissionTier &&
            this.props.user.specialPermissionTier === 'admin' ? (
              <div style={{ marginBottom: 10 }}>
                <p style={{ fontSize: 14, fontWeight: 'bold' }}>Admin</p>
                <a
                  style={styles.modalLink}
                  onClick={() => this.quickFix(this.state.appForModal)}
                >
                  Make Social App
                </a>
                <a
                  style={styles.modalLink}
                  onClick={() => this.makeAdmin(this.state.appForModal)}
                >
                  Make Admin
                </a>
                <a
                  style={styles.modalLink}
                  onClick={() =>
                    this.openEditUserCountModal(this.state.appForModal)
                  }
                >
                  Edit User Count
                </a>
                {/* this.props.user.superAdminPreviewApp === this.state.appForModal._id ? <a style={styles.modalLink} onClick={() => this.setAppForPreview(this.state.appForModal, false)}>Stop Previewing This App</a> : <a style={styles.modalLink} onClick={() => this.setAppForPreview(this.state.appForModal, true)}>Preview This App in Assistant</a> */}
                {!this.state.appForModal.deleted ? (
                  <a
                    style={styles.modalLink}
                    onClick={() => this.deleteApp(this.state.appForModal)}
                  >
                    Delete/Suspend App
                  </a>
                ) : (
                  <a
                    style={styles.modalLink}
                    onClick={() => this.undeleteApp(this.state.appForModal)}
                  >
                    Undelete/Unsuspend App
                  </a>
                )}
              </div>
            ) : null}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.closeAdminAppModal}>Close</Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.showShopifyInfoModal}
          onHide={this.closeShopifyInfoModal}
          centered
          size={'lg'}
        >
          <Modal.Header closeButton>
            <Modal.Title>Shopify Information</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              {this.state.loadingShopifyInfo ? <p>Loading...</p> : null}
              {this.state.shopifyInfoError ? (
                <p>{this.state.shopifyInfoError}</p>
              ) : null}
              {this.state.shopifyInfo && this.state.shopifyInfo.status ? (
                <div>
                  {this.state.shopifyInfo.test ? (
                    <p>
                      <span style={{ fontWeight: 600, color: 'orange' }}>
                        TEST
                      </span>
                    </p>
                  ) : null}
                  <p>
                    <span style={{ fontWeight: 600 }}>Subscription Name:</span>{' '}
                    {this.state.shopifyInfo.name}
                  </p>
                  <p>
                    <span style={{ fontWeight: 600 }}>Status:</span>{' '}
                    {this.state.shopifyInfo.status}
                  </p>
                  <p>
                    <span style={{ fontWeight: 600 }}>Interval:</span>{' '}
                    {this.state.shopifyInfo.shopifyChargeType}
                  </p>
                  <p>
                    <span style={{ fontWeight: 600 }}>Price:</span> $
                    {this.state.shopifyInfo.price}
                  </p>
                  <p>
                    <span style={{ fontWeight: 600 }}>Activated On:</span>{' '}
                    {this.state.shopifyInfo.activated_on}
                  </p>
                  <p>
                    <span style={{ fontWeight: 600 }}>Next Billing On:</span>{' '}
                    {this.state.shopifyInfo.billing_on}
                  </p>
                  {this.state.shopifyInfo.trial_days ? (
                    <p>
                      <span style={{ fontWeight: 600 }}>Trial Length:</span>{' '}
                      {this.state.shopifyInfo.trial_days} (Trial Ends on:{' '}
                      {this.state.shopifyInfo.trial_ends_on})
                    </p>
                  ) : null}
                </div>
              ) : null}
            </div>
          </Modal.Body>
          <Modal.Footer>
            {this.state.shopifyInfo &&
            this.state.shopifyInfo.status &&
            this.state.shopifyInfo.status === 'active' ? (
              <Button onClick={this.cancelShopifySub}>
                Cancel Subscription
              </Button>
            ) : null}
            {this.state.shopifyInfo &&
            this.state.shopifyInfo.status &&
            this.state.shopifyInfo.status === 'cancelled' ? (
              <Button onClick={this.markAsCancelled}>Mark As Cancelled</Button>
            ) : null}
            {this.state.shopifyClearTokens || this.state.shopifyInfoError ? (
              <Button onClick={this.clearShopifyTokens}>
                Clear Shopify Tokens
              </Button>
            ) : null}
            <Button onClick={this.closeShopifyInfoModal}>Close</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

AllAppsPage.propTypes = {
  user: PropTypes.object.isRequired,
  app: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

function mapStateToProps(state: any, ownProps: any) {
  return {
    app: state.app,
    user: state.user,
    openConfigPage: ownProps.openConfigPage,
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    actions: {
      user: bindActionCreators(userActions, dispatch),
      app: bindActionCreators(appActions, dispatch),
      admin: bindActionCreators(adminActions, dispatch),
      event: bindActionCreators(eventActions, dispatch),
    },
  };
}

const connector = connect(mapStateToProps, mapDispatchToProps);
export default compose(connector, withRouter)(AllAppsPage);
